/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * HTTP request/response schemas generated from specs/api/components/
 * Run `npm run monsterrat:generate:contracts` to regenerate.
 */

import { z } from 'zod';

// ══════════════════════════════════════════════════════════════
// Response Schemas
// ══════════════════════════════════════════════════════════════

/** Standard error response envelope */
export const ApiErrorResponseSchema = z.object({
    error: z.object({
      code: z.enum(['VALIDATION_FAILED', 'NOT_FOUND', 'USER_NOT_FOUND', 'ALREADY_EXISTS', 'CONFLICT', 'RATE_LIMITED', 'QUOTA_EXCEEDED', 'UNAUTHORIZED', 'TOKEN_EXPIRED', 'FORBIDDEN', 'AI_CONSENT_REQUIRED', 'ACCOUNT_DELETED', 'INTERNAL_ERROR', 'SERVICE_UNAVAILABLE', 'AI_SERVICE_ERROR', 'AI_PROVIDER_ERROR', 'AI_EMPTY_RESPONSE', 'AI_STREAM_ERROR', 'DATABASE_ERROR', 'ROLEPLAY_SLOTS_FULL', 'ROLEPLAY_SLOT_NOT_FOUND', 'ROLEPLAY_SETUP_INVALID', 'ROLEPLAY_TEMPLATE_NOT_FOUND', 'ROLEPLAY_COLLECTION_NOT_FOUND', 'VOCAB_ITEM_NOT_FOUND', 'VOCAB_SET_NOT_FOUND', 'EXPRESSION_ITEM_NOT_FOUND', 'GRAMMAR_POINT_NOT_FOUND', 'SESSION_BUSY', 'STREAM_ERROR']),
      message: z.string(),
      category: z.enum(['VALIDATION', 'BUSINESS', 'AUTH', 'UNEXPECTED']),
    }),
    details: z.object({}).optional(),
    referenceId: z.string().optional(),
  }).passthrough();
const _ApiErrorResponseStrict = z.object({
    error: z.object({
      code: z.enum(['VALIDATION_FAILED', 'NOT_FOUND', 'USER_NOT_FOUND', 'ALREADY_EXISTS', 'CONFLICT', 'RATE_LIMITED', 'QUOTA_EXCEEDED', 'UNAUTHORIZED', 'TOKEN_EXPIRED', 'FORBIDDEN', 'AI_CONSENT_REQUIRED', 'ACCOUNT_DELETED', 'INTERNAL_ERROR', 'SERVICE_UNAVAILABLE', 'AI_SERVICE_ERROR', 'AI_PROVIDER_ERROR', 'AI_EMPTY_RESPONSE', 'AI_STREAM_ERROR', 'DATABASE_ERROR', 'ROLEPLAY_SLOTS_FULL', 'ROLEPLAY_SLOT_NOT_FOUND', 'ROLEPLAY_SETUP_INVALID', 'ROLEPLAY_TEMPLATE_NOT_FOUND', 'ROLEPLAY_COLLECTION_NOT_FOUND', 'VOCAB_ITEM_NOT_FOUND', 'VOCAB_SET_NOT_FOUND', 'EXPRESSION_ITEM_NOT_FOUND', 'GRAMMAR_POINT_NOT_FOUND', 'SESSION_BUSY', 'STREAM_ERROR']),
      message: z.string(),
      category: z.enum(['VALIDATION', 'BUSINESS', 'AUTH', 'UNEXPECTED']),
    }),
    details: z.object({}).optional(),
    referenceId: z.string().optional(),
  });
export type ApiErrorResponse = z.infer<typeof _ApiErrorResponseStrict>;

/** Standard success response wrapper (success + data) */
export const SuccessEnvelopeSchema = z.object({
    success: z.boolean(),
  }).passthrough();
const _SuccessEnvelopeStrict = z.object({
    success: z.boolean(),
  });
export type SuccessEnvelope = z.infer<typeof _SuccessEnvelopeStrict>;

export const SubscriptionSchema = z.object({
    hasAccess: z.boolean(),
    entitlementId: z.string().optional(),
    productId: z.string().optional(),
    expiresAt: z.string().optional(),
    isGracePeriod: z.boolean(),
    source: z.string(),
    trialDaysLeft: z.number().int().optional(),
    verifiedAt: z.string().optional(),
  }).passthrough();
const _SubscriptionStrict = z.object({
    hasAccess: z.boolean(),
    entitlementId: z.string().optional(),
    productId: z.string().optional(),
    expiresAt: z.string().optional(),
    isGracePeriod: z.boolean(),
    source: z.string(),
    trialDaysLeft: z.number().int().optional(),
    verifiedAt: z.string().optional(),
  });
export type Subscription = z.infer<typeof _SubscriptionStrict>;

/** GET /api/user/me response */
export const UserProfileSchema = z.object({
    id: z.string(),
    email: z.string(),
    name: z.string().optional(),
    displayName: z.string().optional(),
    voiceExercisesEnabled: z.boolean().optional(),
    coursePreferences: z.array(z.object({
      courseId: z.string(),
      country: z.string(),
      sourceLocale: z.string(),
      targetLocale: z.string(),
      lessonLanguage: z.string(),
      azureTtsVoice: z.string(),
      ttsProvider: z.string(),
      sttProvider: z.string(),
    })).optional(),
    maxCourses: z.number().int().optional(),
    onboardingCompleted: z.boolean().optional(),
    debugContextSnapshots: z.boolean().optional(),
    lessonFeedbackEnabled: z.boolean().optional(),
    preferencesUpdatedAt: z.string().optional(),
    aiConsentGrantedAt: z.string().nullable().optional(),
    aiConsentVersion: z.number().optional(),
    createdAt: z.string(),
    updatedAt: z.string(),
    subscription: z.object({
      hasAccess: z.boolean(),
      entitlementId: z.string().optional(),
      productId: z.string().optional(),
      expiresAt: z.string().optional(),
      isGracePeriod: z.boolean(),
      source: z.string(),
      trialDaysLeft: z.number().int().optional(),
      verifiedAt: z.string().optional(),
    }).optional(),
  }).passthrough();
const _UserProfileStrict = z.object({
    id: z.string(),
    email: z.string(),
    name: z.string().optional(),
    displayName: z.string().optional(),
    voiceExercisesEnabled: z.boolean().optional(),
    coursePreferences: z.array(z.object({
      courseId: z.string(),
      country: z.string(),
      sourceLocale: z.string(),
      targetLocale: z.string(),
      lessonLanguage: z.string(),
      azureTtsVoice: z.string(),
      ttsProvider: z.string(),
      sttProvider: z.string(),
    })).optional(),
    maxCourses: z.number().int().optional(),
    onboardingCompleted: z.boolean().optional(),
    debugContextSnapshots: z.boolean().optional(),
    lessonFeedbackEnabled: z.boolean().optional(),
    preferencesUpdatedAt: z.string().optional(),
    aiConsentGrantedAt: z.string().nullable().optional(),
    aiConsentVersion: z.number().optional(),
    createdAt: z.string(),
    updatedAt: z.string(),
    subscription: z.object({
      hasAccess: z.boolean(),
      entitlementId: z.string().optional(),
      productId: z.string().optional(),
      expiresAt: z.string().optional(),
      isGracePeriod: z.boolean(),
      source: z.string(),
      trialDaysLeft: z.number().int().optional(),
      verifiedAt: z.string().optional(),
    }).optional(),
  });
export type UserProfile = z.infer<typeof _UserProfileStrict>;

export const ConversationMessageSchema = z.object({
    id: z.string(),
    role: z.enum(['user', 'assistant']),
    content: z.string().nullable(),
    toolCalls: z.array(z.object({
      tool: z.string().optional(),
      args: z.object({}).optional(),
      result: z.object({}).optional(),
    })).optional(),
    analysis: z.object({}).optional(),
    metadata: z.object({}).optional(),
    createdAt: z.string(),
  }).passthrough();
const _ConversationMessageStrict = z.object({
    id: z.string(),
    role: z.enum(['user', 'assistant']),
    content: z.string().nullable(),
    toolCalls: z.array(z.object({
      tool: z.string().optional(),
      args: z.object({}).optional(),
      result: z.object({}).optional(),
    })).optional(),
    analysis: z.object({}).optional(),
    metadata: z.object({}).optional(),
    createdAt: z.string(),
  });
export type ConversationMessage = z.infer<typeof _ConversationMessageStrict>;

/** Core session fields shared across create, detail, and list responses */
export const SessionSummarySchema = z.object({
    id: z.string(),
    title: z.string().nullable(),
    flowType: z.string(),
    hasAnalysis: z.boolean(),
    hasOpening: z.boolean(),
    courseId: z.string(),
    sourceLocale: z.string(),
    targetLocale: z.string(),
    createdAt: z.string(),
    updatedAt: z.string(),
  }).passthrough();
const _SessionSummaryStrict = z.object({
    id: z.string(),
    title: z.string().nullable(),
    flowType: z.string(),
    hasAnalysis: z.boolean(),
    hasOpening: z.boolean(),
    courseId: z.string(),
    sourceLocale: z.string(),
    targetLocale: z.string(),
    createdAt: z.string(),
    updatedAt: z.string(),
  });
export type SessionSummary = z.infer<typeof _SessionSummaryStrict>;

/** Metadata for the freshly created roleplay_runner session (dev driver). */
export const DevRoleplayStartResponseSchema = z.object({
    sessionId: z.string(),
    situationSlug: z.string(),
    courseId: z.string(),
    sourceLocale: z.string(),
    targetLocale: z.string(),
    firstSpeaker: z.enum(['user', 'ai']),
    flowType: z.string(),
    title: z.string(),
  }).passthrough();
const _DevRoleplayStartResponseStrict = z.object({
    sessionId: z.string(),
    situationSlug: z.string(),
    courseId: z.string(),
    sourceLocale: z.string(),
    targetLocale: z.string(),
    firstSpeaker: z.enum(['user', 'ai']),
    flowType: z.string(),
    title: z.string(),
  });
export type DevRoleplayStartResponse = z.infer<typeof _DevRoleplayStartResponseStrict>;

/** A disposable test user (dev only). `password` is returned ONLY by the create call — it is never stored, so it cannot be recovered later. */
export const DevTestUserSchema = z.object({
    userId: z.string(),
    email: z.string(),
    password: z.string().optional(),
    runId: z.string().nullable().optional(),
    expiresAt: z.string(),
  }).passthrough();
const _DevTestUserStrict = z.object({
    userId: z.string(),
    email: z.string(),
    password: z.string().optional(),
    runId: z.string().nullable().optional(),
    expiresAt: z.string(),
  });
export type DevTestUser = z.infer<typeof _DevTestUserStrict>;

/** Every test user currently alive (dev only). */
export const DevTestUserListResponseSchema = z.object({
    testUsers: z.array(z.object({
      userId: z.string(),
      email: z.string(),
      password: z.string().optional(),
      runId: z.string().nullable().optional(),
      expiresAt: z.string(),
    })),
    total: z.number().int(),
  }).passthrough();
const _DevTestUserListResponseStrict = z.object({
    testUsers: z.array(z.object({
      userId: z.string(),
      email: z.string(),
      password: z.string().optional(),
      runId: z.string().nullable().optional(),
      expiresAt: z.string(),
    })),
    total: z.number().int(),
  });
export type DevTestUserListResponse = z.infer<typeof _DevTestUserListResponseStrict>;

/** The recovery code Supabase would have emailed. Generating it does not send mail and does not consume the per-address send throttle. */
export const DevTestUserOtpResponseSchema = z.object({
    code: z.string(),
  }).passthrough();
const _DevTestUserOtpResponseStrict = z.object({
    code: z.string(),
  });
export type DevTestUserOtpResponse = z.infer<typeof _DevTestUserOtpResponseStrict>;

/** Result of a test-user sweep (dev only). */
export const DevTestUserCleanupResponseSchema = z.object({
    deleted: z.number().int(),
    failed: z.number().int(),
  }).passthrough();
const _DevTestUserCleanupResponseStrict = z.object({
    deleted: z.number().int(),
    failed: z.number().int(),
  });
export type DevTestUserCleanupResponse = z.infer<typeof _DevTestUserCleanupResponseStrict>;

/** One assistant turn from the dev roleplay driver — the streamed scene prose plus the parsed directive(s) and the raw tool calls (the same data persisted to conversation_messages.tool_calls). */
export const DevRoleplayTurnSchema = z.object({
    aiText: z.string().nullable(),
    directives: z.record(z.string(), z.any()).nullable(),
    toolCalls: z.array(z.record(z.string(), z.any())).nullable(),
    userMessageId: z.string().nullable(),
    aiMessageId: z.string().nullable(),
  }).passthrough();
const _DevRoleplayTurnStrict = z.object({
    aiText: z.string().nullable(),
    directives: z.record(z.string(), z.any()).nullable(),
    toolCalls: z.array(z.record(z.string(), z.any())).nullable(),
    userMessageId: z.string().nullable(),
    aiMessageId: z.string().nullable(),
  });
export type DevRoleplayTurn = z.infer<typeof _DevRoleplayTurnStrict>;

/** GET /api/conversation/sessions/:id/messages response */
export const SessionMessagesResponseSchema = z.object({
    session: z.object({
      id: z.string(),
      title: z.string().nullable(),
      flowType: z.string(),
      hasAnalysis: z.boolean(),
      hasOpening: z.boolean(),
      courseId: z.string(),
      sourceLocale: z.string(),
      targetLocale: z.string(),
      createdAt: z.string(),
      updatedAt: z.string(),
    }),
    messages: z.array(z.object({
      id: z.string(),
      role: z.enum(['user', 'assistant']),
      content: z.string().nullable(),
      toolCalls: z.array(z.object({
        tool: z.string().optional(),
        args: z.object({}).optional(),
        result: z.object({}).optional(),
      })).optional(),
      analysis: z.object({}).optional(),
      metadata: z.object({}).optional(),
      createdAt: z.string(),
    })),
  }).passthrough();
const _SessionMessagesResponseStrict = z.object({
    session: z.object({
      id: z.string(),
      title: z.string().nullable(),
      flowType: z.string(),
      hasAnalysis: z.boolean(),
      hasOpening: z.boolean(),
      courseId: z.string(),
      sourceLocale: z.string(),
      targetLocale: z.string(),
      createdAt: z.string(),
      updatedAt: z.string(),
    }),
    messages: z.array(z.object({
      id: z.string(),
      role: z.enum(['user', 'assistant']),
      content: z.string().nullable(),
      toolCalls: z.array(z.object({
        tool: z.string().optional(),
        args: z.object({}).optional(),
        result: z.object({}).optional(),
      })).optional(),
      analysis: z.object({}).optional(),
      metadata: z.object({}).optional(),
      createdAt: z.string(),
    })),
  });
export type SessionMessagesResponse = z.infer<typeof _SessionMessagesResponseStrict>;

/** POST /api/dev/sessions/:id/messages/send (dev endpoint) or WireMock mock */
export const SendMessageResponseSchema = z.object({
    userMessage: z.object({
      id: z.string(),
      role: z.enum(['user', 'assistant']),
      content: z.string().nullable(),
      toolCalls: z.array(z.object({
        tool: z.string().optional(),
        args: z.object({}).optional(),
        result: z.object({}).optional(),
      })).optional(),
      analysis: z.object({}).optional(),
      metadata: z.object({}).optional(),
      createdAt: z.string(),
    }),
    aiMessage: z.object({
      id: z.string(),
      role: z.enum(['user', 'assistant']),
      content: z.string().nullable(),
      toolCalls: z.array(z.object({
        tool: z.string().optional(),
        args: z.object({}).optional(),
        result: z.object({}).optional(),
      })).optional(),
      analysis: z.object({}).optional(),
      metadata: z.object({}).optional(),
      createdAt: z.string(),
    }),
  }).passthrough();
const _SendMessageResponseStrict = z.object({
    userMessage: z.object({
      id: z.string(),
      role: z.enum(['user', 'assistant']),
      content: z.string().nullable(),
      toolCalls: z.array(z.object({
        tool: z.string().optional(),
        args: z.object({}).optional(),
        result: z.object({}).optional(),
      })).optional(),
      analysis: z.object({}).optional(),
      metadata: z.object({}).optional(),
      createdAt: z.string(),
    }),
    aiMessage: z.object({
      id: z.string(),
      role: z.enum(['user', 'assistant']),
      content: z.string().nullable(),
      toolCalls: z.array(z.object({
        tool: z.string().optional(),
        args: z.object({}).optional(),
        result: z.object({}).optional(),
      })).optional(),
      analysis: z.object({}).optional(),
      metadata: z.object({}).optional(),
      createdAt: z.string(),
    }),
  });
export type SendMessageResponse = z.infer<typeof _SendMessageResponseStrict>;

/** POST /api/conversation/sessions/:id/messages/:mid/analyze response */
export const AnalyzeResponseSchema = z.object({
    analysis: z.object({
      grammarErrors: z.array(z.object({
        text: z.string().optional(),
        error: z.string().optional(),
        correction: z.string().optional(),
        errorType: z.string().optional(),
        explanation: z.string().optional(),
      })).optional(),
      lessonReferences: z.array(z.object({
        slug: z.string().optional(),
        title: z.string().optional(),
      })).optional(),
    }).nullable(),
  }).passthrough();
const _AnalyzeResponseStrict = z.object({
    analysis: z.object({
      grammarErrors: z.array(z.object({
        text: z.string().optional(),
        error: z.string().optional(),
        correction: z.string().optional(),
        errorType: z.string().optional(),
        explanation: z.string().optional(),
      })).optional(),
      lessonReferences: z.array(z.object({
        slug: z.string().optional(),
        title: z.string().optional(),
      })).optional(),
    }).nullable(),
  });
export type AnalyzeResponse = z.infer<typeof _AnalyzeResponseStrict>;

export const LessonSummarySchema = z.object({
    id: z.string(),
    slug: z.string(),
    title: z.string(),
    description: z.string().optional(),
    level: z.string(),
    category: z.string().optional(),
    estimatedMins: z.number().optional(),
    orderIndex: z.number().optional(),
    completion: z.object({
      bestScore: z.number().optional(),
      totalAttempts: z.number().optional(),
      nextReviewDate: z.string().optional(),
    }).nullable(),
  }).passthrough();
const _LessonSummaryStrict = z.object({
    id: z.string(),
    slug: z.string(),
    title: z.string(),
    description: z.string().optional(),
    level: z.string(),
    category: z.string().optional(),
    estimatedMins: z.number().optional(),
    orderIndex: z.number().optional(),
    completion: z.object({
      bestScore: z.number().optional(),
      totalAttempts: z.number().optional(),
      nextReviewDate: z.string().optional(),
    }).nullable(),
  });
export type LessonSummary = z.infer<typeof _LessonSummaryStrict>;

/** GET /api/lessons/path response */
export const LessonPathResponseSchema = z.object({
    sections: z.array(z.object({
      slug: z.string(),
      title: z.string(),
      category: z.string(),
      lessons: z.array(z.object({
        id: z.string(),
        slug: z.string(),
        title: z.string(),
        description: z.string().optional(),
        level: z.string(),
        category: z.string().optional(),
        estimatedMins: z.number().optional(),
        orderIndex: z.number().optional(),
        completion: z.object({
          bestScore: z.number().optional(),
          totalAttempts: z.number().optional(),
          nextReviewDate: z.string().optional(),
        }).nullable(),
      })),
    })),
    continueLesson: z.object({
      slug: z.string().optional(),
      title: z.string().optional(),
      category: z.string().optional(),
    }).optional(),
  }).passthrough();
const _LessonPathResponseStrict = z.object({
    sections: z.array(z.object({
      slug: z.string(),
      title: z.string(),
      category: z.string(),
      lessons: z.array(z.object({
        id: z.string(),
        slug: z.string(),
        title: z.string(),
        description: z.string().optional(),
        level: z.string(),
        category: z.string().optional(),
        estimatedMins: z.number().optional(),
        orderIndex: z.number().optional(),
        completion: z.object({
          bestScore: z.number().optional(),
          totalAttempts: z.number().optional(),
          nextReviewDate: z.string().optional(),
        }).nullable(),
      })),
    })),
    continueLesson: z.object({
      slug: z.string().optional(),
      title: z.string().optional(),
      category: z.string().optional(),
    }).optional(),
  });
export type LessonPathResponse = z.infer<typeof _LessonPathResponseStrict>;

/** GET /api/lessons/scheduled response */
export const ScheduledLessonsResponseSchema = z.object({
    total: z.number(),
    lessons: z.array(z.object({
      lesson: z.object({
        id: z.string(),
        slug: z.string(),
        title: z.string(),
        description: z.string().optional(),
        level: z.string(),
        category: z.string().optional(),
        estimatedMins: z.number().optional(),
        orderIndex: z.number().optional(),
        completion: z.object({
          bestScore: z.number().optional(),
          totalAttempts: z.number().optional(),
          nextReviewDate: z.string().optional(),
        }).nullable(),
      }),
      lastScore: z.number(),
      lastCompletedAt: z.string(),
      attemptNumber: z.number(),
      dueDate: z.string(),
      overdueDays: z.number(),
    })),
  }).passthrough();
const _ScheduledLessonsResponseStrict = z.object({
    total: z.number(),
    lessons: z.array(z.object({
      lesson: z.object({
        id: z.string(),
        slug: z.string(),
        title: z.string(),
        description: z.string().optional(),
        level: z.string(),
        category: z.string().optional(),
        estimatedMins: z.number().optional(),
        orderIndex: z.number().optional(),
        completion: z.object({
          bestScore: z.number().optional(),
          totalAttempts: z.number().optional(),
          nextReviewDate: z.string().optional(),
        }).nullable(),
      }),
      lastScore: z.number(),
      lastCompletedAt: z.string(),
      attemptNumber: z.number(),
      dueDate: z.string(),
      overdueDays: z.number(),
    })),
  });
export type ScheduledLessonsResponse = z.infer<typeof _ScheduledLessonsResponseStrict>;

/** GET /api/lessons response */
export const LessonListResponseSchema = z.object({
    lessons: z.array(z.object({
      id: z.string(),
      title: z.string(),
      description: z.string().optional(),
      slug: z.string(),
      level: z.string(),
      category: z.string().optional(),
      estimatedMins: z.number().optional(),
      orderIndex: z.number().optional(),
    })),
    total: z.number(),
    limit: z.number(),
    offset: z.number(),
  }).passthrough();
const _LessonListResponseStrict = z.object({
    lessons: z.array(z.object({
      id: z.string(),
      title: z.string(),
      description: z.string().optional(),
      slug: z.string(),
      level: z.string(),
      category: z.string().optional(),
      estimatedMins: z.number().optional(),
      orderIndex: z.number().optional(),
    })),
    total: z.number(),
    limit: z.number(),
    offset: z.number(),
  });
export type LessonListResponse = z.infer<typeof _LessonListResponseStrict>;

/** GET /api/lessons/recommended response. An empty `lessons` array means the learner has no error patterns yet; the client renders its own localized copy for that case. */
export const LessonRecommendedResponseSchema = z.object({
    lessons: z.array(z.object({
      errorType: z.string(),
      errorCount: z.number(),
      competenceSlug: z.string().nullable().optional(),
      lesson: z.object({
        id: z.string(),
        slug: z.string(),
        title: z.string(),
      }),
    })),
  }).passthrough();
const _LessonRecommendedResponseStrict = z.object({
    lessons: z.array(z.object({
      errorType: z.string(),
      errorCount: z.number(),
      competenceSlug: z.string().nullable().optional(),
      lesson: z.object({
        id: z.string(),
        slug: z.string(),
        title: z.string(),
      }),
    })),
  });
export type LessonRecommendedResponse = z.infer<typeof _LessonRecommendedResponseStrict>;

/** GET /api/lessons/index response (compact index for AI search) */
export const LessonIndexResponseSchema = z.object({
    lessons: z.array(z.object({
      slug: z.string(),
      title: z.string(),
      level: z.string(),
      category: z.string(),
      keywords: z.array(z.string()).optional(),
      errorTypes: z.array(z.string()).optional(),
    })),
  }).passthrough();
const _LessonIndexResponseStrict = z.object({
    lessons: z.array(z.object({
      slug: z.string(),
      title: z.string(),
      level: z.string(),
      category: z.string(),
      keywords: z.array(z.string()).optional(),
      errorTypes: z.array(z.string()).optional(),
    })),
  });
export type LessonIndexResponse = z.infer<typeof _LessonIndexResponseStrict>;

/** GET /api/lessons/:slug response */
export const LessonDetailResponseSchema = z.object({
    id: z.string(),
    title: z.string(),
    description: z.string().nullable(),
    slug: z.string(),
    level: z.string(),
    category: z.string(),
    estimatedMins: z.number().nullable(),
    content: z.record(z.string(), z.any()),
    exercises: z.array(z.object({
      id: z.string(),
      type: z.string(),
      title: z.string().optional(),
      instructions: z.string().optional(),
      content: z.record(z.string(), z.any()).optional(),
      orderIndex: z.number(),
      points: z.number().optional(),
    })),
    isPublished: z.boolean(),
    deprecated: z.object({
      at: z.string().optional(),
      replacedBy: z.object({
        id: z.string().optional(),
        slug: z.string().optional(),
        title: z.string().optional(),
      }).optional(),
    }).optional(),
  }).passthrough();
const _LessonDetailResponseStrict = z.object({
    id: z.string(),
    title: z.string(),
    description: z.string().nullable(),
    slug: z.string(),
    level: z.string(),
    category: z.string(),
    estimatedMins: z.number().nullable(),
    content: z.record(z.string(), z.any()),
    exercises: z.array(z.object({
      id: z.string(),
      type: z.string(),
      title: z.string().optional(),
      instructions: z.string().optional(),
      content: z.record(z.string(), z.any()).optional(),
      orderIndex: z.number(),
      points: z.number().optional(),
    })),
    isPublished: z.boolean(),
    deprecated: z.object({
      at: z.string().optional(),
      replacedBy: z.object({
        id: z.string().optional(),
        slug: z.string().optional(),
        title: z.string().optional(),
      }).optional(),
    }).optional(),
  });
export type LessonDetailResponse = z.infer<typeof _LessonDetailResponseStrict>;

/** POST /api/lessons/:slug/complete response */
export const LessonCompleteResponseSchema = z.object({
    id: z.string(),
    score: z.number(),
    attemptNumber: z.number(),
    nextReviewDate: z.string(),
    isNewHighScore: z.boolean().optional(),
    previousBestScore: z.number().nullable().optional(),
  }).passthrough();
const _LessonCompleteResponseStrict = z.object({
    id: z.string(),
    score: z.number(),
    attemptNumber: z.number(),
    nextReviewDate: z.string(),
    isNewHighScore: z.boolean().optional(),
    previousBestScore: z.number().nullable().optional(),
  });
export type LessonCompleteResponse = z.infer<typeof _LessonCompleteResponseStrict>;

/** POST /api/lessons/search and POST /api/lessons/ai-search response */
export const LessonSearchResponseSchema = z.object({
    results: z.array(z.object({
      slug: z.string(),
      title: z.string(),
      description: z.string().optional(),
      level: z.string(),
      category: z.string(),
      globalOrder: z.number().optional(),
      relevance: z.number().optional(),
    })),
  }).passthrough();
const _LessonSearchResponseStrict = z.object({
    results: z.array(z.object({
      slug: z.string(),
      title: z.string(),
      description: z.string().optional(),
      level: z.string(),
      category: z.string(),
      globalOrder: z.number().optional(),
      relevance: z.number().optional(),
    })),
  });
export type LessonSearchResponse = z.infer<typeof _LessonSearchResponseStrict>;

/** POST /api/lessons/generate response */
export const GenerateLessonResponseSchema = z.object({
    lessonId: z.string().optional(),
    draftId: z.string().optional(),
    content: z.record(z.string(), z.any()).optional(),
    isPublished: z.boolean(),
  }).passthrough();
const _GenerateLessonResponseStrict = z.object({
    lessonId: z.string().optional(),
    draftId: z.string().optional(),
    content: z.record(z.string(), z.any()).optional(),
    isPublished: z.boolean(),
  });
export type GenerateLessonResponse = z.infer<typeof _GenerateLessonResponseStrict>;

/** GET /api/lessons/draft/:id response */
export const LessonDraftResponseSchema = z.object({
    id: z.string(),
    title: z.string(),
    slug: z.string(),
    level: z.string(),
    errorType: z.string(),
    content: z.record(z.string(), z.any()).optional(),
    status: z.string(),
    createdAt: z.string(),
  }).passthrough();
const _LessonDraftResponseStrict = z.object({
    id: z.string(),
    title: z.string(),
    slug: z.string(),
    level: z.string(),
    errorType: z.string(),
    content: z.record(z.string(), z.any()).optional(),
    status: z.string(),
    createdAt: z.string(),
  });
export type LessonDraftResponse = z.infer<typeof _LessonDraftResponseStrict>;

/** GET /api/lessons/:slug/history response */
export const LessonHistoryResponseSchema = z.object({
    lessonSlug: z.string(),
    lessonTitle: z.string(),
    totalAttempts: z.number(),
    bestScore: z.number().nullable(),
    completions: z.array(z.object({
      id: z.string(),
      score: z.number(),
      attemptNumber: z.number(),
      nextReviewDate: z.string(),
      completedAt: z.string(),
    })),
  }).passthrough();
const _LessonHistoryResponseStrict = z.object({
    lessonSlug: z.string(),
    lessonTitle: z.string(),
    totalAttempts: z.number(),
    bestScore: z.number().nullable(),
    completions: z.array(z.object({
      id: z.string(),
      score: z.number(),
      attemptNumber: z.number(),
      nextReviewDate: z.string(),
      completedAt: z.string(),
    })),
  });
export type LessonHistoryResponse = z.infer<typeof _LessonHistoryResponseStrict>;

/** POST /api/lessons/:slug/generate-exercises response */
export const ExerciseGenerationResponseSchema = z.object({
    exercises: z.array(z.record(z.string(), z.any())),
  }).passthrough();
const _ExerciseGenerationResponseStrict = z.object({
    exercises: z.array(z.record(z.string(), z.any())),
  });
export type ExerciseGenerationResponse = z.infer<typeof _ExerciseGenerationResponseStrict>;

/** POST /api/lessons/quick-practice response */
export const QuickPracticeResponseSchema = z.object({
    id: z.string(),
    content: z.record(z.string(), z.any()),
  }).passthrough();
const _QuickPracticeResponseStrict = z.object({
    id: z.string(),
    content: z.record(z.string(), z.any()),
  });
export type QuickPracticeResponse = z.infer<typeof _QuickPracticeResponseStrict>;

/** GET /api/account/deletion-status response */
export const DeletionStatusResponseSchema = z.object({
    hasPendingRequest: z.boolean(),
    requestId: z.string().optional(),
    requestedAt: z.string().optional(),
    scheduledFor: z.string().optional(),
    daysRemaining: z.number().optional(),
  }).passthrough();
const _DeletionStatusResponseStrict = z.object({
    hasPendingRequest: z.boolean(),
    requestId: z.string().optional(),
    requestedAt: z.string().optional(),
    scheduledFor: z.string().optional(),
    daysRemaining: z.number().optional(),
  });
export type DeletionStatusResponse = z.infer<typeof _DeletionStatusResponseStrict>;

/** POST /api/reports/ai-content response */
export const ReportCreateResponseSchema = z.object({
    success: z.boolean(),
    message: z.string().optional(),
    reportId: z.string().optional(),
    createdAt: z.string().optional(),
    duplicate: z.boolean().optional(),
  }).passthrough();
const _ReportCreateResponseStrict = z.object({
    success: z.boolean(),
    message: z.string().optional(),
    reportId: z.string().optional(),
    createdAt: z.string().optional(),
    duplicate: z.boolean().optional(),
  });
export type ReportCreateResponse = z.infer<typeof _ReportCreateResponseStrict>;

/** Locale description in its own language (not translated) */
export const NativeLocaleInfoSchema = z.object({
    language: z.string(),
    variant: z.string(),
    variantHint: z.string(),
    testPhrase: z.string(),
  }).passthrough();
const _NativeLocaleInfoStrict = z.object({
    language: z.string(),
    variant: z.string(),
    variantHint: z.string(),
    testPhrase: z.string(),
  });
export type NativeLocaleInfo = z.infer<typeof _NativeLocaleInfoStrict>;

/** An Azure Neural TTS voice option */
export const AzureVoiceSchema = z.object({
    id: z.string(),
    label: z.string(),
  }).passthrough();
const _AzureVoiceStrict = z.object({
    id: z.string(),
    label: z.string(),
  });
export type AzureVoice = z.infer<typeof _AzureVoiceStrict>;

/** Per-language pronunciation assessment feature flags. Determines which Azure SDK features to request and what feedback the agent can give. */
export const PronunciationFeaturesSchema = z.object({
    phonemeLabels: z.boolean(),
    syllables: z.boolean(),
    nbestPhonemes: z.boolean(),
    prosody: z.boolean(),
  }).passthrough();
const _PronunciationFeaturesStrict = z.object({
    phonemeLabels: z.boolean(),
    syllables: z.boolean(),
    nbestPhonemes: z.boolean(),
    prosody: z.boolean(),
  });
export type PronunciationFeatures = z.infer<typeof _PronunciationFeaturesStrict>;

/** Azure Speech provider configuration for a locale. Fields are present only when the corresponding capability is true. */
export const AzureSpeechConfigSchema = z.object({
    ttsVoice: z.string().optional(),
    sttLocale: z.string().optional(),
    availableVoices: z.array(z.object({
      id: z.string(),
      label: z.string(),
    })).optional(),
    pronunciationFeatures: z.object({
      phonemeLabels: z.boolean(),
      syllables: z.boolean(),
      nbestPhonemes: z.boolean(),
      prosody: z.boolean(),
    }).optional(),
  }).passthrough();
const _AzureSpeechConfigStrict = z.object({
    ttsVoice: z.string().optional(),
    sttLocale: z.string().optional(),
    availableVoices: z.array(z.object({
      id: z.string(),
      label: z.string(),
    })).optional(),
    pronunciationFeatures: z.object({
      phonemeLabels: z.boolean(),
      syllables: z.boolean(),
      nbestPhonemes: z.boolean(),
      prosody: z.boolean(),
    }).optional(),
  });
export type AzureSpeechConfig = z.infer<typeof _AzureSpeechConfigStrict>;

/** Provider-agnostic feature flags. Each boolean is true if any configured provider supports that feature for this language. The client uses these to gate UI features without knowing which provider delivers them.
 */
export const LanguageCapabilitiesSchema = z.object({
    tts: z.boolean(),
    stt: z.boolean(),
    pronunciation: z.boolean(),
    translation: z.boolean(),
  }).passthrough();
const _LanguageCapabilitiesStrict = z.object({
    tts: z.boolean(),
    stt: z.boolean(),
    pronunciation: z.boolean(),
    translation: z.boolean(),
  });
export type LanguageCapabilities = z.infer<typeof _LanguageCapabilitiesStrict>;

/** Metadata for a single locale */
export const LocaleMetadataSchema = z.object({
    code: z.string(),
    capabilities: z.object({
      tts: z.boolean(),
      stt: z.boolean(),
      pronunciation: z.boolean(),
      translation: z.boolean(),
    }),
    speech: z.object({
      azure: z.object({
        ttsVoice: z.string().optional(),
        sttLocale: z.string().optional(),
        availableVoices: z.array(z.object({
          id: z.string(),
          label: z.string(),
        })).optional(),
        pronunciationFeatures: z.object({
          phonemeLabels: z.boolean(),
          syllables: z.boolean(),
          nbestPhonemes: z.boolean(),
          prosody: z.boolean(),
        }).optional(),
      }).optional(),
    }),
    native: z.object({
      language: z.string(),
      variant: z.string(),
      variantHint: z.string(),
      testPhrase: z.string(),
    }),
  }).passthrough();
const _LocaleMetadataStrict = z.object({
    code: z.string(),
    capabilities: z.object({
      tts: z.boolean(),
      stt: z.boolean(),
      pronunciation: z.boolean(),
      translation: z.boolean(),
    }),
    speech: z.object({
      azure: z.object({
        ttsVoice: z.string().optional(),
        sttLocale: z.string().optional(),
        availableVoices: z.array(z.object({
          id: z.string(),
          label: z.string(),
        })).optional(),
        pronunciationFeatures: z.object({
          phonemeLabels: z.boolean(),
          syllables: z.boolean(),
          nbestPhonemes: z.boolean(),
          prosody: z.boolean(),
        }).optional(),
      }).optional(),
    }),
    native: z.object({
      language: z.string(),
      variant: z.string(),
      variantHint: z.string(),
      testPhrase: z.string(),
    }),
  });
export type LocaleMetadata = z.infer<typeof _LocaleMetadataStrict>;

/** A language course (source → target) */
export const LanguageCourseSchema = z.object({
    id: z.string(),
    sourceBase: z.string(),
    targetBase: z.string(),
    defaultSourceLocale: z.string(),
    defaultTargetLocale: z.string(),
    sourceVariants: z.array(z.string()),
    targetVariants: z.array(z.string()),
    hasLessons: z.boolean(),
  }).passthrough();
const _LanguageCourseStrict = z.object({
    id: z.string(),
    sourceBase: z.string(),
    targetBase: z.string(),
    defaultSourceLocale: z.string(),
    defaultTargetLocale: z.string(),
    sourceVariants: z.array(z.string()),
    targetVariants: z.array(z.string()),
    hasLessons: z.boolean(),
  });
export type LanguageCourse = z.infer<typeof _LanguageCourseStrict>;

/** Country to locale mapping */
export const CountryConfigSchema = z.object({
    code: z.string(),
    emoji: z.string(),
    locales: z.array(z.string()),
  }).passthrough();
const _CountryConfigStrict = z.object({
    code: z.string(),
    emoji: z.string(),
    locales: z.array(z.string()),
  });
export type CountryConfig = z.infer<typeof _CountryConfigStrict>;

/** GET /api/courses response */
export const CoursesResponseSchema = z.object({
    courses: z.array(z.object({
      id: z.string(),
      sourceBase: z.string(),
      targetBase: z.string(),
      defaultSourceLocale: z.string(),
      defaultTargetLocale: z.string(),
      sourceVariants: z.array(z.string()),
      targetVariants: z.array(z.string()),
      hasLessons: z.boolean(),
    })),
    locales: z.array(z.object({
      code: z.string(),
      capabilities: z.object({
        tts: z.boolean(),
        stt: z.boolean(),
        pronunciation: z.boolean(),
        translation: z.boolean(),
      }),
      speech: z.object({
        azure: z.object({
          ttsVoice: z.string().optional(),
          sttLocale: z.string().optional(),
          availableVoices: z.array(z.object({
            id: z.string(),
            label: z.string(),
          })).optional(),
          pronunciationFeatures: z.object({
            phonemeLabels: z.boolean(),
            syllables: z.boolean(),
            nbestPhonemes: z.boolean(),
            prosody: z.boolean(),
          }).optional(),
        }).optional(),
      }),
      native: z.object({
        language: z.string(),
        variant: z.string(),
        variantHint: z.string(),
        testPhrase: z.string(),
      }),
    })),
    countries: z.array(z.object({
      code: z.string(),
      emoji: z.string(),
      locales: z.array(z.string()),
    })),
  }).passthrough();
const _CoursesResponseStrict = z.object({
    courses: z.array(z.object({
      id: z.string(),
      sourceBase: z.string(),
      targetBase: z.string(),
      defaultSourceLocale: z.string(),
      defaultTargetLocale: z.string(),
      sourceVariants: z.array(z.string()),
      targetVariants: z.array(z.string()),
      hasLessons: z.boolean(),
    })),
    locales: z.array(z.object({
      code: z.string(),
      capabilities: z.object({
        tts: z.boolean(),
        stt: z.boolean(),
        pronunciation: z.boolean(),
        translation: z.boolean(),
      }),
      speech: z.object({
        azure: z.object({
          ttsVoice: z.string().optional(),
          sttLocale: z.string().optional(),
          availableVoices: z.array(z.object({
            id: z.string(),
            label: z.string(),
          })).optional(),
          pronunciationFeatures: z.object({
            phonemeLabels: z.boolean(),
            syllables: z.boolean(),
            nbestPhonemes: z.boolean(),
            prosody: z.boolean(),
          }).optional(),
        }).optional(),
      }),
      native: z.object({
        language: z.string(),
        variant: z.string(),
        variantHint: z.string(),
        testPhrase: z.string(),
      }),
    })),
    countries: z.array(z.object({
      code: z.string(),
      emoji: z.string(),
      locales: z.array(z.string()),
    })),
  });
export type CoursesResponse = z.infer<typeof _CoursesResponseStrict>;

/** POST /api/account/request-deletion response */
export const RequestDeletionResponseSchema = z.object({
    success: z.boolean(),
    message: z.string().optional(),
    requestId: z.string().optional(),
    scheduledFor: z.string().optional(),
    daysRemaining: z.number().int().optional(),
  }).passthrough();
const _RequestDeletionResponseStrict = z.object({
    success: z.boolean(),
    message: z.string().optional(),
    requestId: z.string().optional(),
    scheduledFor: z.string().optional(),
    daysRemaining: z.number().int().optional(),
  });
export type RequestDeletionResponse = z.infer<typeof _RequestDeletionResponseStrict>;

/** POST /api/account/cancel-deletion response */
export const CancelDeletionResponseSchema = z.object({
    success: z.boolean(),
    message: z.string().optional(),
  }).passthrough();
const _CancelDeletionResponseStrict = z.object({
    success: z.boolean(),
    message: z.string().optional(),
  });
export type CancelDeletionResponse = z.infer<typeof _CancelDeletionResponseStrict>;

/** POST /api/jobs/process-deletions response */
export const DeletionJobResponseSchema = z.object({
    success: z.boolean(),
    processed: z.number().int(),
    failed: z.number().int(),
    durationMs: z.number().int(),
  }).passthrough();
const _DeletionJobResponseStrict = z.object({
    success: z.boolean(),
    processed: z.number().int(),
    failed: z.number().int(),
    durationMs: z.number().int(),
  });
export type DeletionJobResponse = z.infer<typeof _DeletionJobResponseStrict>;

/** POST /api/jobs/reconcile-subscriptions response (single batch) */
export const ReconciliationBatchResponseSchema = z.object({
    success: z.boolean(),
    processed: z.number().int(),
    updated: z.number().int(),
    errors: z.number().int(),
    mismatches: z.array(z.record(z.string(), z.any())).optional(),
    continuationToken: z.string().optional(),
    durationMs: z.number().int(),
  }).passthrough();
const _ReconciliationBatchResponseStrict = z.object({
    success: z.boolean(),
    processed: z.number().int(),
    updated: z.number().int(),
    errors: z.number().int(),
    mismatches: z.array(z.record(z.string(), z.any())).optional(),
    continuationToken: z.string().optional(),
    durationMs: z.number().int(),
  });
export type ReconciliationBatchResponse = z.infer<typeof _ReconciliationBatchResponseStrict>;

/** POST /api/jobs/reconcile-subscriptions?full=true response */
export const ReconciliationFullResponseSchema = z.object({
    success: z.boolean(),
    processed: z.number().int(),
    updated: z.number().int(),
    errors: z.number().int(),
    mismatches: z.array(z.record(z.string(), z.any())).optional(),
    durationMs: z.number().int(),
  }).passthrough();
const _ReconciliationFullResponseStrict = z.object({
    success: z.boolean(),
    processed: z.number().int(),
    updated: z.number().int(),
    errors: z.number().int(),
    mismatches: z.array(z.record(z.string(), z.any())).optional(),
    durationMs: z.number().int(),
  });
export type ReconciliationFullResponse = z.infer<typeof _ReconciliationFullResponseStrict>;

/** POST /api/admin/prompts/reload response */
export const PromptsReloadResponseSchema = z.object({
    status: z.string(),
    count: z.number().int().optional(),
  }).passthrough();
const _PromptsReloadResponseStrict = z.object({
    status: z.string(),
    count: z.number().int().optional(),
  });
export type PromptsReloadResponse = z.infer<typeof _PromptsReloadResponseStrict>;

/** Full admin view of an in-app message */
export const AdminMessageItemSchema = z.object({
    id: z.string(),
    displayType: z.enum(['banner', 'modal', 'blocking']),
    i18nKey: z.string(),
    priority: z.number().int(),
    minAppVersion: z.string().optional(),
    maxAppVersion: z.string().optional(),
    platforms: z.array(z.string()),
    locales: z.array(z.string()),
    subscriptionPlans: z.array(z.string()),
    startsAt: z.string(),
    expiresAt: z.string().optional(),
    isActive: z.boolean(),
    dismissable: z.boolean(),
    showOnce: z.boolean(),
    actionType: z.string().optional(),
    actionPayload: z.string().optional(),
    createdAt: z.string(),
    updatedAt: z.string(),
  }).passthrough();
const _AdminMessageItemStrict = z.object({
    id: z.string(),
    displayType: z.enum(['banner', 'modal', 'blocking']),
    i18nKey: z.string(),
    priority: z.number().int(),
    minAppVersion: z.string().optional(),
    maxAppVersion: z.string().optional(),
    platforms: z.array(z.string()),
    locales: z.array(z.string()),
    subscriptionPlans: z.array(z.string()),
    startsAt: z.string(),
    expiresAt: z.string().optional(),
    isActive: z.boolean(),
    dismissable: z.boolean(),
    showOnce: z.boolean(),
    actionType: z.string().optional(),
    actionPayload: z.string().optional(),
    createdAt: z.string(),
    updatedAt: z.string(),
  });
export type AdminMessageItem = z.infer<typeof _AdminMessageItemStrict>;

/** Single admin message response */
export const AdminMessageResponseSchema = z.object({
    message: z.object({
      id: z.string(),
      displayType: z.enum(['banner', 'modal', 'blocking']),
      i18nKey: z.string(),
      priority: z.number().int(),
      minAppVersion: z.string().optional(),
      maxAppVersion: z.string().optional(),
      platforms: z.array(z.string()),
      locales: z.array(z.string()),
      subscriptionPlans: z.array(z.string()),
      startsAt: z.string(),
      expiresAt: z.string().optional(),
      isActive: z.boolean(),
      dismissable: z.boolean(),
      showOnce: z.boolean(),
      actionType: z.string().optional(),
      actionPayload: z.string().optional(),
      createdAt: z.string(),
      updatedAt: z.string(),
    }),
  }).passthrough();
const _AdminMessageResponseStrict = z.object({
    message: z.object({
      id: z.string(),
      displayType: z.enum(['banner', 'modal', 'blocking']),
      i18nKey: z.string(),
      priority: z.number().int(),
      minAppVersion: z.string().optional(),
      maxAppVersion: z.string().optional(),
      platforms: z.array(z.string()),
      locales: z.array(z.string()),
      subscriptionPlans: z.array(z.string()),
      startsAt: z.string(),
      expiresAt: z.string().optional(),
      isActive: z.boolean(),
      dismissable: z.boolean(),
      showOnce: z.boolean(),
      actionType: z.string().optional(),
      actionPayload: z.string().optional(),
      createdAt: z.string(),
      updatedAt: z.string(),
    }),
  });
export type AdminMessageResponse = z.infer<typeof _AdminMessageResponseStrict>;

/** List of admin messages */
export const AdminMessageListResponseSchema = z.object({
    messages: z.array(z.object({
      id: z.string(),
      displayType: z.enum(['banner', 'modal', 'blocking']),
      i18nKey: z.string(),
      priority: z.number().int(),
      minAppVersion: z.string().optional(),
      maxAppVersion: z.string().optional(),
      platforms: z.array(z.string()),
      locales: z.array(z.string()),
      subscriptionPlans: z.array(z.string()),
      startsAt: z.string(),
      expiresAt: z.string().optional(),
      isActive: z.boolean(),
      dismissable: z.boolean(),
      showOnce: z.boolean(),
      actionType: z.string().optional(),
      actionPayload: z.string().optional(),
      createdAt: z.string(),
      updatedAt: z.string(),
    })),
  }).passthrough();
const _AdminMessageListResponseStrict = z.object({
    messages: z.array(z.object({
      id: z.string(),
      displayType: z.enum(['banner', 'modal', 'blocking']),
      i18nKey: z.string(),
      priority: z.number().int(),
      minAppVersion: z.string().optional(),
      maxAppVersion: z.string().optional(),
      platforms: z.array(z.string()),
      locales: z.array(z.string()),
      subscriptionPlans: z.array(z.string()),
      startsAt: z.string(),
      expiresAt: z.string().optional(),
      isActive: z.boolean(),
      dismissable: z.boolean(),
      showOnce: z.boolean(),
      actionType: z.string().optional(),
      actionPayload: z.string().optional(),
      createdAt: z.string(),
      updatedAt: z.string(),
    })),
  });
export type AdminMessageListResponse = z.infer<typeof _AdminMessageListResponseStrict>;

/** GET /api/health response */
export const HealthResponseSchema = z.object({
    status: z.string(),
    commit: z.string().optional(),
    branch: z.string().optional(),
    buildTime: z.string().optional(),
    timestamp: z.string(),
    environment: z.string().optional(),
  }).passthrough();
const _HealthResponseStrict = z.object({
    status: z.string(),
    commit: z.string().optional(),
    branch: z.string().optional(),
    buildTime: z.string().optional(),
    timestamp: z.string(),
    environment: z.string().optional(),
  });
export type HealthResponse = z.infer<typeof _HealthResponseStrict>;

/** GET /api/config response */
export const ConfigResponseSchema = z.object({
    supabaseUrl: z.string().optional(),
    supabasePublishableKey: z.string().optional(),
  }).passthrough();
const _ConfigResponseStrict = z.object({
    supabaseUrl: z.string().optional(),
    supabasePublishableKey: z.string().optional(),
  });
export type ConfigResponse = z.infer<typeof _ConfigResponseStrict>;

/** GET /api/conversation/sessions response */
export const SessionListResponseSchema = z.object({
    sessions: z.array(z.object({
      id: z.string(),
      title: z.string().nullable(),
      flowType: z.string(),
      hasAnalysis: z.boolean(),
      hasOpening: z.boolean(),
      courseId: z.string(),
      sourceLocale: z.string(),
      targetLocale: z.string(),
      messageCount: z.number(),
      role: z.string(),
      createdAt: z.string(),
      updatedAt: z.string(),
    })),
  }).passthrough();
const _SessionListResponseStrict = z.object({
    sessions: z.array(z.object({
      id: z.string(),
      title: z.string().nullable(),
      flowType: z.string(),
      hasAnalysis: z.boolean(),
      hasOpening: z.boolean(),
      courseId: z.string(),
      sourceLocale: z.string(),
      targetLocale: z.string(),
      messageCount: z.number(),
      role: z.string(),
      createdAt: z.string(),
      updatedAt: z.string(),
    })),
  });
export type SessionListResponse = z.infer<typeof _SessionListResponseStrict>;

/** GET /api/reports/ai-content/my-reports response */
export const MyReportsResponseSchema = z.object({
    reports: z.array(z.object({
      id: z.string(),
      messageId: z.string(),
      messageText: z.string().optional(),
      status: z.string(),
      createdAt: z.string(),
      resolution: z.string().optional(),
    })),
    total: z.number(),
    limit: z.number(),
    offset: z.number(),
  }).passthrough();
const _MyReportsResponseStrict = z.object({
    reports: z.array(z.object({
      id: z.string(),
      messageId: z.string(),
      messageText: z.string().optional(),
      status: z.string(),
      createdAt: z.string(),
      resolution: z.string().optional(),
    })),
    total: z.number(),
    limit: z.number(),
    offset: z.number(),
  });
export type MyReportsResponse = z.infer<typeof _MyReportsResponseStrict>;

/** POST /api/lessons/check-updates response */
export const CheckLessonUpdatesResponseSchema = z.object({
    updatedCourses: z.array(z.object({
      courseId: z.string(),
      currentVersion: z.string(),
    })),
  }).passthrough();
const _CheckLessonUpdatesResponseStrict = z.object({
    updatedCourses: z.array(z.object({
      courseId: z.string(),
      currentVersion: z.string(),
    })),
  });
export type CheckLessonUpdatesResponse = z.infer<typeof _CheckLessonUpdatesResponseStrict>;

/** A single in-app message for the client to display */
export const InAppMessagePayloadSchema = z.object({
    id: z.string(),
    displayType: z.enum(['banner', 'modal', 'blocking']),
    i18nKey: z.string(),
    priority: z.number().int(),
    dismissable: z.boolean(),
    actionType: z.string().optional(),
    actionPayload: z.string().optional(),
  }).passthrough();
const _InAppMessagePayloadStrict = z.object({
    id: z.string(),
    displayType: z.enum(['banner', 'modal', 'blocking']),
    i18nKey: z.string(),
    priority: z.number().int(),
    dismissable: z.boolean(),
    actionType: z.string().optional(),
    actionPayload: z.string().optional(),
  });
export type InAppMessagePayload = z.infer<typeof _InAppMessagePayloadStrict>;

/** GET /api/messages/active response */
export const ActiveMessagesResponseSchema = z.object({
    messages: z.array(z.object({
      id: z.string(),
      displayType: z.enum(['banner', 'modal', 'blocking']),
      i18nKey: z.string(),
      priority: z.number().int(),
      dismissable: z.boolean(),
      actionType: z.string().optional(),
      actionPayload: z.string().optional(),
    })),
  }).passthrough();
const _ActiveMessagesResponseStrict = z.object({
    messages: z.array(z.object({
      id: z.string(),
      displayType: z.enum(['banner', 'modal', 'blocking']),
      i18nKey: z.string(),
      priority: z.number().int(),
      dismissable: z.boolean(),
      actionType: z.string().optional(),
      actionPayload: z.string().optional(),
    })),
  });
export type ActiveMessagesResponse = z.infer<typeof _ActiveMessagesResponseStrict>;

/** Slot summary returned in list responses (no scenarioDetails to keep payload small). Bilingual fields are locale-keyed objects resolved on the client. */
export const RolePlaySlotSummarySchema = z.object({
    id: z.string(),
    position: z.number().int(),
    title: z.record(z.string(), z.any()),
    scenario: z.record(z.string(), z.any()),
    userRole: z.record(z.string(), z.any()),
    aiRole: z.record(z.string(), z.any()),
    firstSpeaker: z.enum(['user', 'ai']),
    conversationId: z.string(),
    createdAt: z.string(),
    updatedAt: z.string(),
  }).passthrough();
const _RolePlaySlotSummaryStrict = z.object({
    id: z.string(),
    position: z.number().int(),
    title: z.record(z.string(), z.any()),
    scenario: z.record(z.string(), z.any()),
    userRole: z.record(z.string(), z.any()),
    aiRole: z.record(z.string(), z.any()),
    firstSpeaker: z.enum(['user', 'ai']),
    conversationId: z.string(),
    createdAt: z.string(),
    updatedAt: z.string(),
  });
export type RolePlaySlotSummary = z.infer<typeof _RolePlaySlotSummaryStrict>;

/** Full slot including scenarioDetails. Bilingual fields are locale-keyed objects resolved on the client. */
export const RolePlaySlotDetailSchema = z.object({
    id: z.string(),
    position: z.number().int(),
    title: z.record(z.string(), z.any()),
    scenario: z.record(z.string(), z.any()),
    scenarioDetails: z.record(z.string(), z.any()),
    userRole: z.record(z.string(), z.any()),
    aiRole: z.record(z.string(), z.any()),
    firstSpeaker: z.enum(['user', 'ai']),
    conversationId: z.string(),
    createdAt: z.string(),
    updatedAt: z.string(),
  }).passthrough();
const _RolePlaySlotDetailStrict = z.object({
    id: z.string(),
    position: z.number().int(),
    title: z.record(z.string(), z.any()),
    scenario: z.record(z.string(), z.any()),
    scenarioDetails: z.record(z.string(), z.any()),
    userRole: z.record(z.string(), z.any()),
    aiRole: z.record(z.string(), z.any()),
    firstSpeaker: z.enum(['user', 'ai']),
    conversationId: z.string(),
    createdAt: z.string(),
    updatedAt: z.string(),
  });
export type RolePlaySlotDetail = z.infer<typeof _RolePlaySlotDetailStrict>;

/** GET /api/roleplay/slots response */
export const RolePlaySlotListResponseSchema = z.object({
    slots: z.array(z.object({
      id: z.string(),
      position: z.number().int(),
      title: z.record(z.string(), z.any()),
      scenario: z.record(z.string(), z.any()),
      userRole: z.record(z.string(), z.any()),
      aiRole: z.record(z.string(), z.any()),
      firstSpeaker: z.enum(['user', 'ai']),
      conversationId: z.string(),
      createdAt: z.string(),
      updatedAt: z.string(),
    })),
    cap: z.number().int(),
  }).passthrough();
const _RolePlaySlotListResponseStrict = z.object({
    slots: z.array(z.object({
      id: z.string(),
      position: z.number().int(),
      title: z.record(z.string(), z.any()),
      scenario: z.record(z.string(), z.any()),
      userRole: z.record(z.string(), z.any()),
      aiRole: z.record(z.string(), z.any()),
      firstSpeaker: z.enum(['user', 'ai']),
      conversationId: z.string(),
      createdAt: z.string(),
      updatedAt: z.string(),
    })),
    cap: z.number().int(),
  });
export type RolePlaySlotListResponse = z.infer<typeof _RolePlaySlotListResponseStrict>;

/** GET /api/roleplay/slots/:id and POST /api/roleplay/slots/:id/restart response */
export const RolePlaySlotDetailResponseSchema = z.object({
    slot: z.object({
      id: z.string(),
      position: z.number().int(),
      title: z.record(z.string(), z.any()),
      scenario: z.record(z.string(), z.any()),
      scenarioDetails: z.record(z.string(), z.any()),
      userRole: z.record(z.string(), z.any()),
      aiRole: z.record(z.string(), z.any()),
      firstSpeaker: z.enum(['user', 'ai']),
      conversationId: z.string(),
      createdAt: z.string(),
      updatedAt: z.string(),
    }),
  }).passthrough();
const _RolePlaySlotDetailResponseStrict = z.object({
    slot: z.object({
      id: z.string(),
      position: z.number().int(),
      title: z.record(z.string(), z.any()),
      scenario: z.record(z.string(), z.any()),
      scenarioDetails: z.record(z.string(), z.any()),
      userRole: z.record(z.string(), z.any()),
      aiRole: z.record(z.string(), z.any()),
      firstSpeaker: z.enum(['user', 'ai']),
      conversationId: z.string(),
      createdAt: z.string(),
      updatedAt: z.string(),
    }),
  });
export type RolePlaySlotDetailResponse = z.infer<typeof _RolePlaySlotDetailResponseStrict>;

/** Template summary for list view (no scenarioDetails, vocabulary, or phrases). Bilingual fields are locale-keyed objects resolved on the client. */
export const RolePlayTemplateSummarySchema = z.object({
    id: z.string(),
    category: z.string(),
    slug: z.string(),
    sortOrder: z.number().int(),
    title: z.record(z.string(), z.any()),
    scenario: z.record(z.string(), z.any()),
    userRole: z.record(z.string(), z.any()),
    aiRole: z.record(z.string(), z.any()),
    firstSpeaker: z.enum(['user', 'ai']),
    targetVariants: z.array(z.string()).optional(),
  }).passthrough();
const _RolePlayTemplateSummaryStrict = z.object({
    id: z.string(),
    category: z.string(),
    slug: z.string(),
    sortOrder: z.number().int(),
    title: z.record(z.string(), z.any()),
    scenario: z.record(z.string(), z.any()),
    userRole: z.record(z.string(), z.any()),
    aiRole: z.record(z.string(), z.any()),
    firstSpeaker: z.enum(['user', 'ai']),
    targetVariants: z.array(z.string()).optional(),
  });
export type RolePlayTemplateSummary = z.infer<typeof _RolePlayTemplateSummaryStrict>;

/** Vocabulary term with translation and context (bilingual with locale variants, resolved on client) */
export const RolePlayVocabularyItemSchema = z.object({
    term: z.record(z.string(), z.any()),
    translation: z.record(z.string(), z.any()),
    context: z.record(z.string(), z.any()),
  }).passthrough();
const _RolePlayVocabularyItemStrict = z.object({
    term: z.record(z.string(), z.any()),
    translation: z.record(z.string(), z.any()),
    context: z.record(z.string(), z.any()),
  });
export type RolePlayVocabularyItem = z.infer<typeof _RolePlayVocabularyItemStrict>;

/** Key phrase with translation and note (bilingual with locale variants, resolved on client) */
export const RolePlayPhraseItemSchema = z.object({
    phrase: z.record(z.string(), z.any()),
    translation: z.record(z.string(), z.any()),
    note: z.record(z.string(), z.any()),
  }).passthrough();
const _RolePlayPhraseItemStrict = z.object({
    phrase: z.record(z.string(), z.any()),
    translation: z.record(z.string(), z.any()),
    note: z.record(z.string(), z.any()),
  });
export type RolePlayPhraseItem = z.infer<typeof _RolePlayPhraseItemStrict>;

/** Full template including vocabulary and phrases. Bilingual fields are locale-keyed objects resolved on the client. Phase 4 added `collectionSlug`, `difficulty`, and the relation-backed `catalogVocab` / `catalogExpressions` arrays — clients should prefer those over the legacy `vocabulary` / `phrases` JSON arrays once present. */
export const RolePlayTemplateDetailSchema = z.object({
    id: z.string(),
    category: z.string(),
    collectionSlug: z.string().optional(),
    difficulty: z.number().int().optional(),
    slug: z.string(),
    title: z.record(z.string(), z.any()),
    scenario: z.record(z.string(), z.any()),
    scenarioDetails: z.record(z.string(), z.any()),
    userRole: z.record(z.string(), z.any()),
    aiRole: z.record(z.string(), z.any()),
    firstSpeaker: z.enum(['user', 'ai']),
    vocabulary: z.array(z.object({
      term: z.record(z.string(), z.any()),
      translation: z.record(z.string(), z.any()),
      context: z.record(z.string(), z.any()),
    })),
    phrases: z.array(z.object({
      phrase: z.record(z.string(), z.any()),
      translation: z.record(z.string(), z.any()),
      note: z.record(z.string(), z.any()),
    })),
    catalogVocab: z.array(z.object({
      id: z.string(),
      lemma: z.string(),
      pos: z.string().optional(),
      translation: z.record(z.string(), z.any()),
      ipa: z.string().optional(),
      ipaVariant: z.string().optional(),
      ipaIsFallback: z.boolean().optional(),
      difficulty: z.number().int().optional(),
      importance: z.number().int(),
      contextNote: z.record(z.string(), z.any()).optional(),
      status: z.enum(['new', 'learning', 'mastered']),
    })).optional(),
    catalogExpressions: z.array(z.object({
      id: z.string(),
      text: z.string(),
      normalized: z.string(),
      translation: z.record(z.string(), z.any()),
      register: z.string().optional(),
      difficulty: z.number().int().optional(),
      importance: z.number().int(),
      contextNote: z.record(z.string(), z.any()).optional(),
      notes: z.record(z.string(), z.any()).optional(),
      status: z.enum(['new', 'learning', 'mastered']),
    })).optional(),
    targetVariants: z.array(z.string()).optional(),
  }).passthrough();
const _RolePlayTemplateDetailStrict = z.object({
    id: z.string(),
    category: z.string(),
    collectionSlug: z.string().optional(),
    difficulty: z.number().int().optional(),
    slug: z.string(),
    title: z.record(z.string(), z.any()),
    scenario: z.record(z.string(), z.any()),
    scenarioDetails: z.record(z.string(), z.any()),
    userRole: z.record(z.string(), z.any()),
    aiRole: z.record(z.string(), z.any()),
    firstSpeaker: z.enum(['user', 'ai']),
    vocabulary: z.array(z.object({
      term: z.record(z.string(), z.any()),
      translation: z.record(z.string(), z.any()),
      context: z.record(z.string(), z.any()),
    })),
    phrases: z.array(z.object({
      phrase: z.record(z.string(), z.any()),
      translation: z.record(z.string(), z.any()),
      note: z.record(z.string(), z.any()),
    })),
    catalogVocab: z.array(z.object({
      id: z.string(),
      lemma: z.string(),
      pos: z.string().optional(),
      translation: z.record(z.string(), z.any()),
      ipa: z.string().optional(),
      ipaVariant: z.string().optional(),
      ipaIsFallback: z.boolean().optional(),
      difficulty: z.number().int().optional(),
      importance: z.number().int(),
      contextNote: z.record(z.string(), z.any()).optional(),
      status: z.enum(['new', 'learning', 'mastered']),
    })).optional(),
    catalogExpressions: z.array(z.object({
      id: z.string(),
      text: z.string(),
      normalized: z.string(),
      translation: z.record(z.string(), z.any()),
      register: z.string().optional(),
      difficulty: z.number().int().optional(),
      importance: z.number().int(),
      contextNote: z.record(z.string(), z.any()).optional(),
      notes: z.record(z.string(), z.any()).optional(),
      status: z.enum(['new', 'learning', 'mastered']),
    })).optional(),
    targetVariants: z.array(z.string()).optional(),
  });
export type RolePlayTemplateDetail = z.infer<typeof _RolePlayTemplateDetailStrict>;

/** GET /api/roleplay/templates response */
export const RolePlayTemplateListResponseSchema = z.object({
    templates: z.array(z.object({
      id: z.string(),
      category: z.string(),
      slug: z.string(),
      sortOrder: z.number().int(),
      title: z.record(z.string(), z.any()),
      scenario: z.record(z.string(), z.any()),
      userRole: z.record(z.string(), z.any()),
      aiRole: z.record(z.string(), z.any()),
      firstSpeaker: z.enum(['user', 'ai']),
      targetVariants: z.array(z.string()).optional(),
    })),
  }).passthrough();
const _RolePlayTemplateListResponseStrict = z.object({
    templates: z.array(z.object({
      id: z.string(),
      category: z.string(),
      slug: z.string(),
      sortOrder: z.number().int(),
      title: z.record(z.string(), z.any()),
      scenario: z.record(z.string(), z.any()),
      userRole: z.record(z.string(), z.any()),
      aiRole: z.record(z.string(), z.any()),
      firstSpeaker: z.enum(['user', 'ai']),
      targetVariants: z.array(z.string()).optional(),
    })),
  });
export type RolePlayTemplateListResponse = z.infer<typeof _RolePlayTemplateListResponseStrict>;

/** GET /api/roleplay/templates/:id response */
export const RolePlayTemplateDetailResponseSchema = z.object({
    template: z.object({
      id: z.string(),
      category: z.string(),
      collectionSlug: z.string().optional(),
      difficulty: z.number().int().optional(),
      slug: z.string(),
      title: z.record(z.string(), z.any()),
      scenario: z.record(z.string(), z.any()),
      scenarioDetails: z.record(z.string(), z.any()),
      userRole: z.record(z.string(), z.any()),
      aiRole: z.record(z.string(), z.any()),
      firstSpeaker: z.enum(['user', 'ai']),
      vocabulary: z.array(z.object({
        term: z.record(z.string(), z.any()),
        translation: z.record(z.string(), z.any()),
        context: z.record(z.string(), z.any()),
      })),
      phrases: z.array(z.object({
        phrase: z.record(z.string(), z.any()),
        translation: z.record(z.string(), z.any()),
        note: z.record(z.string(), z.any()),
      })),
      catalogVocab: z.array(z.object({
        id: z.string(),
        lemma: z.string(),
        pos: z.string().optional(),
        translation: z.record(z.string(), z.any()),
        ipa: z.string().optional(),
        ipaVariant: z.string().optional(),
        ipaIsFallback: z.boolean().optional(),
        difficulty: z.number().int().optional(),
        importance: z.number().int(),
        contextNote: z.record(z.string(), z.any()).optional(),
        status: z.enum(['new', 'learning', 'mastered']),
      })).optional(),
      catalogExpressions: z.array(z.object({
        id: z.string(),
        text: z.string(),
        normalized: z.string(),
        translation: z.record(z.string(), z.any()),
        register: z.string().optional(),
        difficulty: z.number().int().optional(),
        importance: z.number().int(),
        contextNote: z.record(z.string(), z.any()).optional(),
        notes: z.record(z.string(), z.any()).optional(),
        status: z.enum(['new', 'learning', 'mastered']),
      })).optional(),
      targetVariants: z.array(z.string()).optional(),
    }),
  }).passthrough();
const _RolePlayTemplateDetailResponseStrict = z.object({
    template: z.object({
      id: z.string(),
      category: z.string(),
      collectionSlug: z.string().optional(),
      difficulty: z.number().int().optional(),
      slug: z.string(),
      title: z.record(z.string(), z.any()),
      scenario: z.record(z.string(), z.any()),
      scenarioDetails: z.record(z.string(), z.any()),
      userRole: z.record(z.string(), z.any()),
      aiRole: z.record(z.string(), z.any()),
      firstSpeaker: z.enum(['user', 'ai']),
      vocabulary: z.array(z.object({
        term: z.record(z.string(), z.any()),
        translation: z.record(z.string(), z.any()),
        context: z.record(z.string(), z.any()),
      })),
      phrases: z.array(z.object({
        phrase: z.record(z.string(), z.any()),
        translation: z.record(z.string(), z.any()),
        note: z.record(z.string(), z.any()),
      })),
      catalogVocab: z.array(z.object({
        id: z.string(),
        lemma: z.string(),
        pos: z.string().optional(),
        translation: z.record(z.string(), z.any()),
        ipa: z.string().optional(),
        ipaVariant: z.string().optional(),
        ipaIsFallback: z.boolean().optional(),
        difficulty: z.number().int().optional(),
        importance: z.number().int(),
        contextNote: z.record(z.string(), z.any()).optional(),
        status: z.enum(['new', 'learning', 'mastered']),
      })).optional(),
      catalogExpressions: z.array(z.object({
        id: z.string(),
        text: z.string(),
        normalized: z.string(),
        translation: z.record(z.string(), z.any()),
        register: z.string().optional(),
        difficulty: z.number().int().optional(),
        importance: z.number().int(),
        contextNote: z.record(z.string(), z.any()).optional(),
        notes: z.record(z.string(), z.any()).optional(),
        status: z.enum(['new', 'learning', 'mastered']),
      })).optional(),
      targetVariants: z.array(z.string()).optional(),
    }),
  });
export type RolePlayTemplateDetailResponse = z.infer<typeof _RolePlayTemplateDetailResponseStrict>;

/** Mastery status for a vocab/expression item, computed by MasteryService from accumulated counters. */
export const LearnerStatusSchema = z.enum(['new', 'learning', 'mastered']);
const _LearnerStatusStrict = z.enum(['new', 'learning', 'mastered']);
export type LearnerStatus = z.infer<typeof _LearnerStatusStrict>;

/** CEFR proficiency level — the single shared level axis across the catalog, lessons, audio, and progress surfaces (ADR-033 D4). All six levels; C2 is first-class even where C2 *content* is absent (the consumer renders an empty / "próximamente" state, never a hidden level). N-1 caveat: a new client sending level=C2 to an N-1 server returns 400 VALIDATION during staged rollout. */
export const CEFRLevelSchema = z.enum(['A1', 'A2', 'B1', 'B2', 'C1', 'C2']);
const _CEFRLevelStrict = z.enum(['A1', 'A2', 'B1', 'B2', 'C1', 'C2']);
export type CEFRLevel = z.infer<typeof _CEFRLevelStrict>;

/** Collection summary for the catalog grid. Includes per-user completion stats so the client can render progress without a second roundtrip. */
export const RolePlayCollectionSummarySchema = z.object({
    id: z.string(),
    slug: z.string(),
    sortOrder: z.number().int(),
    title: z.record(z.string(), z.any()),
    description: z.record(z.string(), z.any()),
    iconKey: z.string().optional(),
    templateCount: z.number().int(),
    completedCount: z.number().int(),
  }).passthrough();
const _RolePlayCollectionSummaryStrict = z.object({
    id: z.string(),
    slug: z.string(),
    sortOrder: z.number().int(),
    title: z.record(z.string(), z.any()),
    description: z.record(z.string(), z.any()),
    iconKey: z.string().optional(),
    templateCount: z.number().int(),
    completedCount: z.number().int(),
  });
export type RolePlayCollectionSummary = z.infer<typeof _RolePlayCollectionSummaryStrict>;

/** Single collection plus its situations, ordered by `sortOrder`. The `templates` array is the same `RolePlayTemplateSummary` shape used elsewhere in the spec, so the catalog detail screen can reuse the existing card component. */
export const RolePlayCollectionDetailSchema = z.object({
    id: z.string(),
    slug: z.string(),
    sortOrder: z.number().int(),
    title: z.record(z.string(), z.any()),
    description: z.record(z.string(), z.any()),
    iconKey: z.string().optional(),
    templates: z.array(z.object({
      id: z.string(),
      category: z.string(),
      slug: z.string(),
      sortOrder: z.number().int(),
      title: z.record(z.string(), z.any()),
      scenario: z.record(z.string(), z.any()),
      userRole: z.record(z.string(), z.any()),
      aiRole: z.record(z.string(), z.any()),
      firstSpeaker: z.enum(['user', 'ai']),
      targetVariants: z.array(z.string()).optional(),
    })),
  }).passthrough();
const _RolePlayCollectionDetailStrict = z.object({
    id: z.string(),
    slug: z.string(),
    sortOrder: z.number().int(),
    title: z.record(z.string(), z.any()),
    description: z.record(z.string(), z.any()),
    iconKey: z.string().optional(),
    templates: z.array(z.object({
      id: z.string(),
      category: z.string(),
      slug: z.string(),
      sortOrder: z.number().int(),
      title: z.record(z.string(), z.any()),
      scenario: z.record(z.string(), z.any()),
      userRole: z.record(z.string(), z.any()),
      aiRole: z.record(z.string(), z.any()),
      firstSpeaker: z.enum(['user', 'ai']),
      targetVariants: z.array(z.string()).optional(),
    })),
  });
export type RolePlayCollectionDetail = z.infer<typeof _RolePlayCollectionDetailStrict>;

/** GET /api/roleplay/collections response */
export const RolePlayCollectionListResponseSchema = z.object({
    collections: z.array(z.object({
      id: z.string(),
      slug: z.string(),
      sortOrder: z.number().int(),
      title: z.record(z.string(), z.any()),
      description: z.record(z.string(), z.any()),
      iconKey: z.string().optional(),
      templateCount: z.number().int(),
      completedCount: z.number().int(),
    })),
  }).passthrough();
const _RolePlayCollectionListResponseStrict = z.object({
    collections: z.array(z.object({
      id: z.string(),
      slug: z.string(),
      sortOrder: z.number().int(),
      title: z.record(z.string(), z.any()),
      description: z.record(z.string(), z.any()),
      iconKey: z.string().optional(),
      templateCount: z.number().int(),
      completedCount: z.number().int(),
    })),
  });
export type RolePlayCollectionListResponse = z.infer<typeof _RolePlayCollectionListResponseStrict>;

/** GET /api/roleplay/collections/:slug response */
export const RolePlayCollectionDetailResponseSchema = z.object({
    collection: z.object({
      id: z.string(),
      slug: z.string(),
      sortOrder: z.number().int(),
      title: z.record(z.string(), z.any()),
      description: z.record(z.string(), z.any()),
      iconKey: z.string().optional(),
      templates: z.array(z.object({
        id: z.string(),
        category: z.string(),
        slug: z.string(),
        sortOrder: z.number().int(),
        title: z.record(z.string(), z.any()),
        scenario: z.record(z.string(), z.any()),
        userRole: z.record(z.string(), z.any()),
        aiRole: z.record(z.string(), z.any()),
        firstSpeaker: z.enum(['user', 'ai']),
        targetVariants: z.array(z.string()).optional(),
      })),
    }),
  }).passthrough();
const _RolePlayCollectionDetailResponseStrict = z.object({
    collection: z.object({
      id: z.string(),
      slug: z.string(),
      sortOrder: z.number().int(),
      title: z.record(z.string(), z.any()),
      description: z.record(z.string(), z.any()),
      iconKey: z.string().optional(),
      templates: z.array(z.object({
        id: z.string(),
        category: z.string(),
        slug: z.string(),
        sortOrder: z.number().int(),
        title: z.record(z.string(), z.any()),
        scenario: z.record(z.string(), z.any()),
        userRole: z.record(z.string(), z.any()),
        aiRole: z.record(z.string(), z.any()),
        firstSpeaker: z.enum(['user', 'ai']),
        targetVariants: z.array(z.string()).optional(),
      })),
    }),
  });
export type RolePlayCollectionDetailResponse = z.infer<typeof _RolePlayCollectionDetailResponseStrict>;

/** Relation-backed vocabulary item attached to a template. Combines the catalog row, the per-template join row (importance + contextNote), and the caller's mastery status so the preview screen can show a status chip without a second fetch. */
export const RolePlayCatalogVocabSchema = z.object({
    id: z.string(),
    lemma: z.string(),
    pos: z.string().optional(),
    translation: z.record(z.string(), z.any()),
    ipa: z.string().optional(),
    ipaVariant: z.string().optional(),
    ipaIsFallback: z.boolean().optional(),
    difficulty: z.number().int().optional(),
    importance: z.number().int(),
    contextNote: z.record(z.string(), z.any()).optional(),
    status: z.enum(['new', 'learning', 'mastered']),
  }).passthrough();
const _RolePlayCatalogVocabStrict = z.object({
    id: z.string(),
    lemma: z.string(),
    pos: z.string().optional(),
    translation: z.record(z.string(), z.any()),
    ipa: z.string().optional(),
    ipaVariant: z.string().optional(),
    ipaIsFallback: z.boolean().optional(),
    difficulty: z.number().int().optional(),
    importance: z.number().int(),
    contextNote: z.record(z.string(), z.any()).optional(),
    status: z.enum(['new', 'learning', 'mastered']),
  });
export type RolePlayCatalogVocab = z.infer<typeof _RolePlayCatalogVocabStrict>;

/** Relation-backed expression item attached to a template. Same role as RolePlayCatalogVocab. */
export const RolePlayCatalogExpressionSchema = z.object({
    id: z.string(),
    text: z.string(),
    normalized: z.string(),
    translation: z.record(z.string(), z.any()),
    register: z.string().optional(),
    difficulty: z.number().int().optional(),
    importance: z.number().int(),
    contextNote: z.record(z.string(), z.any()).optional(),
    notes: z.record(z.string(), z.any()).optional(),
    status: z.enum(['new', 'learning', 'mastered']),
  }).passthrough();
const _RolePlayCatalogExpressionStrict = z.object({
    id: z.string(),
    text: z.string(),
    normalized: z.string(),
    translation: z.record(z.string(), z.any()),
    register: z.string().optional(),
    difficulty: z.number().int().optional(),
    importance: z.number().int(),
    contextNote: z.record(z.string(), z.any()).optional(),
    notes: z.record(z.string(), z.any()).optional(),
    status: z.enum(['new', 'learning', 'mastered']),
  });
export type RolePlayCatalogExpression = z.infer<typeof _RolePlayCatalogExpressionStrict>;

/** Vocabulary catalog row plus the caller's current usage / mastery state. Returned by GET /api/vocab/items — every sense classified `vocabulary`: a word or fixed lexical item, at most 4 tokens unless the curated catalog says otherwise (ADR-038). `pos` rides on the payload but does NOT decide which list a sense is on; `abandon ship` and `pickup` are typed `idiom` and belong here. */
export const VocabItemSummarySchema = z.object({
    id: z.string(),
    lemma: z.string(),
    pos: z.string().optional(),
    translation: z.record(z.string(), z.any()),
    ipa: z.string().optional(),
    ipaVariant: z.string().optional(),
    ipaIsFallback: z.boolean().optional(),
    difficulty: z.number().int(),
    tags: z.array(z.string()).optional(),
    status: z.enum(['new', 'learning', 'mastered']),
    encounters: z.number().int(),
    productions: z.number().int(),
    struggles: z.number().int(),
    lastUsedAt: z.string().optional(),
    srsDueAt: z.string().optional(),
  }).passthrough();
const _VocabItemSummaryStrict = z.object({
    id: z.string(),
    lemma: z.string(),
    pos: z.string().optional(),
    translation: z.record(z.string(), z.any()),
    ipa: z.string().optional(),
    ipaVariant: z.string().optional(),
    ipaIsFallback: z.boolean().optional(),
    difficulty: z.number().int(),
    tags: z.array(z.string()).optional(),
    status: z.enum(['new', 'learning', 'mastered']),
    encounters: z.number().int(),
    productions: z.number().int(),
    struggles: z.number().int(),
    lastUsedAt: z.string().optional(),
    srsDueAt: z.string().optional(),
  });
export type VocabItemSummary = z.infer<typeof _VocabItemSummaryStrict>;

/** Single vocabulary catalog row with the caller's usage state. Same shape as VocabItemSummary today; carved out as a separate schema for forward compatibility (e.g. richer detail like example sentences in a follow-up). */
export const VocabItemDetailSchema = z.object({
    id: z.string(),
    lemma: z.string(),
    pos: z.string().optional(),
    translation: z.record(z.string(), z.any()),
    ipa: z.string().optional(),
    ipaVariant: z.string().optional(),
    ipaIsFallback: z.boolean().optional(),
    difficulty: z.number().int(),
    tags: z.array(z.string()).optional(),
    status: z.enum(['new', 'learning', 'mastered']),
    encounters: z.number().int(),
    productions: z.number().int(),
    struggles: z.number().int(),
    lastUsedAt: z.string().optional(),
    srsDueAt: z.string().optional(),
  }).passthrough();
const _VocabItemDetailStrict = z.object({
    id: z.string(),
    lemma: z.string(),
    pos: z.string().optional(),
    translation: z.record(z.string(), z.any()),
    ipa: z.string().optional(),
    ipaVariant: z.string().optional(),
    ipaIsFallback: z.boolean().optional(),
    difficulty: z.number().int(),
    tags: z.array(z.string()).optional(),
    status: z.enum(['new', 'learning', 'mastered']),
    encounters: z.number().int(),
    productions: z.number().int(),
    struggles: z.number().int(),
    lastUsedAt: z.string().optional(),
    srsDueAt: z.string().optional(),
  });
export type VocabItemDetail = z.infer<typeof _VocabItemDetailStrict>;

/** GET /api/vocab/items response. */
export const VocabItemListResponseSchema = z.object({
    items: z.array(z.object({
      id: z.string(),
      lemma: z.string(),
      pos: z.string().optional(),
      translation: z.record(z.string(), z.any()),
      ipa: z.string().optional(),
      ipaVariant: z.string().optional(),
      ipaIsFallback: z.boolean().optional(),
      difficulty: z.number().int(),
      tags: z.array(z.string()).optional(),
      status: z.enum(['new', 'learning', 'mastered']),
      encounters: z.number().int(),
      productions: z.number().int(),
      struggles: z.number().int(),
      lastUsedAt: z.string().optional(),
      srsDueAt: z.string().optional(),
    })),
    total: z.number().int(),
    limit: z.number().int(),
    offset: z.number().int(),
  }).passthrough();
const _VocabItemListResponseStrict = z.object({
    items: z.array(z.object({
      id: z.string(),
      lemma: z.string(),
      pos: z.string().optional(),
      translation: z.record(z.string(), z.any()),
      ipa: z.string().optional(),
      ipaVariant: z.string().optional(),
      ipaIsFallback: z.boolean().optional(),
      difficulty: z.number().int(),
      tags: z.array(z.string()).optional(),
      status: z.enum(['new', 'learning', 'mastered']),
      encounters: z.number().int(),
      productions: z.number().int(),
      struggles: z.number().int(),
      lastUsedAt: z.string().optional(),
      srsDueAt: z.string().optional(),
    })),
    total: z.number().int(),
    limit: z.number().int(),
    offset: z.number().int(),
  });
export type VocabItemListResponse = z.infer<typeof _VocabItemListResponseStrict>;

/** GET /api/vocab/items/:id response */
export const VocabItemDetailResponseSchema = z.object({
    item: z.object({
      id: z.string(),
      lemma: z.string(),
      pos: z.string().optional(),
      translation: z.record(z.string(), z.any()),
      ipa: z.string().optional(),
      ipaVariant: z.string().optional(),
      ipaIsFallback: z.boolean().optional(),
      difficulty: z.number().int(),
      tags: z.array(z.string()).optional(),
      status: z.enum(['new', 'learning', 'mastered']),
      encounters: z.number().int(),
      productions: z.number().int(),
      struggles: z.number().int(),
      lastUsedAt: z.string().optional(),
      srsDueAt: z.string().optional(),
    }),
  }).passthrough();
const _VocabItemDetailResponseStrict = z.object({
    item: z.object({
      id: z.string(),
      lemma: z.string(),
      pos: z.string().optional(),
      translation: z.record(z.string(), z.any()),
      ipa: z.string().optional(),
      ipaVariant: z.string().optional(),
      ipaIsFallback: z.boolean().optional(),
      difficulty: z.number().int(),
      tags: z.array(z.string()).optional(),
      status: z.enum(['new', 'learning', 'mastered']),
      encounters: z.number().int(),
      productions: z.number().int(),
      struggles: z.number().int(),
      lastUsedAt: z.string().optional(),
      srsDueAt: z.string().optional(),
    }),
  });
export type VocabItemDetailResponse = z.infer<typeof _VocabItemDetailResponseStrict>;

/** Expression catalog row plus the caller's current usage / mastery state. Returned by GET /api/vocab/expressions — every sense classified `utterance`: a sentence-length thing the learner SAYS. */
export const ExpressionItemSummarySchema = z.object({
    id: z.string(),
    text: z.string(),
    normalized: z.string(),
    translation: z.record(z.string(), z.any()),
    register: z.string().optional(),
    difficulty: z.number().int(),
    notes: z.record(z.string(), z.any()).optional(),
    status: z.enum(['new', 'learning', 'mastered']),
    encounters: z.number().int(),
    productions: z.number().int(),
    struggles: z.number().int(),
    lastUsedAt: z.string().optional(),
    srsDueAt: z.string().optional(),
  }).passthrough();
const _ExpressionItemSummaryStrict = z.object({
    id: z.string(),
    text: z.string(),
    normalized: z.string(),
    translation: z.record(z.string(), z.any()),
    register: z.string().optional(),
    difficulty: z.number().int(),
    notes: z.record(z.string(), z.any()).optional(),
    status: z.enum(['new', 'learning', 'mastered']),
    encounters: z.number().int(),
    productions: z.number().int(),
    struggles: z.number().int(),
    lastUsedAt: z.string().optional(),
    srsDueAt: z.string().optional(),
  });
export type ExpressionItemSummary = z.infer<typeof _ExpressionItemSummaryStrict>;

/** Single expression catalog row with the caller's usage state. */
export const ExpressionItemDetailSchema = z.object({
    id: z.string(),
    text: z.string(),
    normalized: z.string(),
    translation: z.record(z.string(), z.any()),
    register: z.string().optional(),
    difficulty: z.number().int(),
    notes: z.record(z.string(), z.any()).optional(),
    status: z.enum(['new', 'learning', 'mastered']),
    encounters: z.number().int(),
    productions: z.number().int(),
    struggles: z.number().int(),
    lastUsedAt: z.string().optional(),
    srsDueAt: z.string().optional(),
  }).passthrough();
const _ExpressionItemDetailStrict = z.object({
    id: z.string(),
    text: z.string(),
    normalized: z.string(),
    translation: z.record(z.string(), z.any()),
    register: z.string().optional(),
    difficulty: z.number().int(),
    notes: z.record(z.string(), z.any()).optional(),
    status: z.enum(['new', 'learning', 'mastered']),
    encounters: z.number().int(),
    productions: z.number().int(),
    struggles: z.number().int(),
    lastUsedAt: z.string().optional(),
    srsDueAt: z.string().optional(),
  });
export type ExpressionItemDetail = z.infer<typeof _ExpressionItemDetailStrict>;

/** GET /api/vocab/expressions response. NARROWED by ADR-038 without a shape change: the endpoint used to mean "pos is phrasal_verb or idiom" and now means "not browsable vocabulary". 915 senses moved from here to GET /api/vocab/items; none were added, and the UNION of the two endpoints is unchanged — which is what keeps a client that merges them (the mobile due-for-review list) whole. */
export const ExpressionItemListResponseSchema = z.object({
    items: z.array(z.object({
      id: z.string(),
      text: z.string(),
      normalized: z.string(),
      translation: z.record(z.string(), z.any()),
      register: z.string().optional(),
      difficulty: z.number().int(),
      notes: z.record(z.string(), z.any()).optional(),
      status: z.enum(['new', 'learning', 'mastered']),
      encounters: z.number().int(),
      productions: z.number().int(),
      struggles: z.number().int(),
      lastUsedAt: z.string().optional(),
      srsDueAt: z.string().optional(),
    })),
    total: z.number().int(),
    limit: z.number().int(),
    offset: z.number().int(),
  }).passthrough();
const _ExpressionItemListResponseStrict = z.object({
    items: z.array(z.object({
      id: z.string(),
      text: z.string(),
      normalized: z.string(),
      translation: z.record(z.string(), z.any()),
      register: z.string().optional(),
      difficulty: z.number().int(),
      notes: z.record(z.string(), z.any()).optional(),
      status: z.enum(['new', 'learning', 'mastered']),
      encounters: z.number().int(),
      productions: z.number().int(),
      struggles: z.number().int(),
      lastUsedAt: z.string().optional(),
      srsDueAt: z.string().optional(),
    })),
    total: z.number().int(),
    limit: z.number().int(),
    offset: z.number().int(),
  });
export type ExpressionItemListResponse = z.infer<typeof _ExpressionItemListResponseStrict>;

/** GET /api/vocab/expressions/:id response */
export const ExpressionItemDetailResponseSchema = z.object({
    item: z.object({
      id: z.string(),
      text: z.string(),
      normalized: z.string(),
      translation: z.record(z.string(), z.any()),
      register: z.string().optional(),
      difficulty: z.number().int(),
      notes: z.record(z.string(), z.any()).optional(),
      status: z.enum(['new', 'learning', 'mastered']),
      encounters: z.number().int(),
      productions: z.number().int(),
      struggles: z.number().int(),
      lastUsedAt: z.string().optional(),
      srsDueAt: z.string().optional(),
    }),
  }).passthrough();
const _ExpressionItemDetailResponseStrict = z.object({
    item: z.object({
      id: z.string(),
      text: z.string(),
      normalized: z.string(),
      translation: z.record(z.string(), z.any()),
      register: z.string().optional(),
      difficulty: z.number().int(),
      notes: z.record(z.string(), z.any()).optional(),
      status: z.enum(['new', 'learning', 'mastered']),
      encounters: z.number().int(),
      productions: z.number().int(),
      struggles: z.number().int(),
      lastUsedAt: z.string().optional(),
      srsDueAt: z.string().optional(),
    }),
  });
export type ExpressionItemDetailResponse = z.infer<typeof _ExpressionItemDetailResponseStrict>;

/** Per-user aggregate mastery counts for one side of the catalog. `due` is the review-queue size (usage rows with srsDueAt <= now, any status) and overlaps learning/mastered — it is not a fourth status. */
export const VocabStatusCountsSchema = z.object({
    new: z.number().int(),
    learning: z.number().int(),
    mastered: z.number().int(),
    due: z.number().int(),
  }).passthrough();
const _VocabStatusCountsStrict = z.object({
    new: z.number().int(),
    learning: z.number().int(),
    mastered: z.number().int(),
    due: z.number().int(),
  });
export type VocabStatusCounts = z.infer<typeof _VocabStatusCountsStrict>;

/** Per-CEFR-level progress for the leveled "Your vocabulary" surface (ADR-033). `total` counts distinct HEADWORDS whose primary sense sits at this level — NOT senses: marks credit only the primary sense today, so per-sense denominators would strand every non-primary sense at "new" forever and cap each polysemous word below 100%. `due` is the review-queue size at this level. */
export const VocabLevelCountsSchema = z.object({
    total: z.number().int(),
    mastered: z.number().int(),
    learning: z.number().int(),
    new: z.number().int(),
    due: z.number().int(),
  }).passthrough();
const _VocabLevelCountsStrict = z.object({
    total: z.number().int(),
    mastered: z.number().int(),
    learning: z.number().int(),
    new: z.number().int(),
    due: z.number().int(),
  });
export type VocabLevelCounts = z.infer<typeof _VocabLevelCountsStrict>;

/** One capability, and why it is where it is. Three states, never a boolean — a boolean forces every partial case to round to an extreme (spec TCP-001). */
export const TargetCapabilitySchema = z.object({
    state: z.enum(['full', 'reduced', 'off']),
    reason: z.string(),
    coverage: z.number().optional(),
  }).passthrough();
const _TargetCapabilityStrict = z.object({
    state: z.enum(['full', 'reduced', 'off']),
    reason: z.string(),
    coverage: z.number().optional(),
  });
export type TargetCapability = z.infer<typeof _TargetCapabilityStrict>;

/** The per-capability profile for one (source, target) pair. */
export const TargetCapabilitiesSchema = z.object({
    vocabularySrs: z.object({
      state: z.enum(['full', 'reduced', 'off']),
      reason: z.string(),
      coverage: z.number().optional(),
    }),
    scenarios: z.object({
      state: z.enum(['full', 'reduced', 'off']),
      reason: z.string(),
      coverage: z.number().optional(),
    }),
    wordIpaDisplay: z.object({
      state: z.enum(['full', 'reduced', 'off']),
      reason: z.string(),
      coverage: z.number().optional(),
    }),
    wordPronunciationDrill: z.object({
      state: z.enum(['full', 'reduced', 'off']),
      reason: z.string(),
      coverage: z.number().optional(),
    }),
    pronunciationScore: z.object({
      state: z.enum(['full', 'reduced', 'off']),
      reason: z.string(),
      coverage: z.number().optional(),
    }),
    phonemeFeedback: z.object({
      state: z.enum(['full', 'reduced', 'off']),
      reason: z.string(),
      coverage: z.number().optional(),
    }),
    soundMapGuidance: z.object({
      state: z.enum(['full', 'reduced', 'off']),
      reason: z.string(),
      coverage: z.number().optional(),
    }),
    soundMapProgress: z.object({
      state: z.enum(['full', 'reduced', 'off']),
      reason: z.string(),
      coverage: z.number().optional(),
    }),
    competenceMap: z.object({
      state: z.enum(['full', 'reduced', 'off']),
      reason: z.string(),
      coverage: z.number().optional(),
    }),
    competenceProbes: z.object({
      state: z.enum(['full', 'reduced', 'off']),
      reason: z.string(),
      coverage: z.number().optional(),
    }),
  }).passthrough();
const _TargetCapabilitiesStrict = z.object({
    vocabularySrs: z.object({
      state: z.enum(['full', 'reduced', 'off']),
      reason: z.string(),
      coverage: z.number().optional(),
    }),
    scenarios: z.object({
      state: z.enum(['full', 'reduced', 'off']),
      reason: z.string(),
      coverage: z.number().optional(),
    }),
    wordIpaDisplay: z.object({
      state: z.enum(['full', 'reduced', 'off']),
      reason: z.string(),
      coverage: z.number().optional(),
    }),
    wordPronunciationDrill: z.object({
      state: z.enum(['full', 'reduced', 'off']),
      reason: z.string(),
      coverage: z.number().optional(),
    }),
    pronunciationScore: z.object({
      state: z.enum(['full', 'reduced', 'off']),
      reason: z.string(),
      coverage: z.number().optional(),
    }),
    phonemeFeedback: z.object({
      state: z.enum(['full', 'reduced', 'off']),
      reason: z.string(),
      coverage: z.number().optional(),
    }),
    soundMapGuidance: z.object({
      state: z.enum(['full', 'reduced', 'off']),
      reason: z.string(),
      coverage: z.number().optional(),
    }),
    soundMapProgress: z.object({
      state: z.enum(['full', 'reduced', 'off']),
      reason: z.string(),
      coverage: z.number().optional(),
    }),
    competenceMap: z.object({
      state: z.enum(['full', 'reduced', 'off']),
      reason: z.string(),
      coverage: z.number().optional(),
    }),
    competenceProbes: z.object({
      state: z.enum(['full', 'reduced', 'off']),
      reason: z.string(),
      coverage: z.number().optional(),
    }),
  });
export type TargetCapabilities = z.infer<typeof _TargetCapabilitiesStrict>;

/** GET /api/courses/capabilities — what this course can offer this learner. Spec: docs/specs/api/target-capability-profile.api.md */
export const TargetCapabilitiesResponseSchema = z.object({
    sourceLocale: z.string(),
    targetLocale: z.string(),
    capabilities: z.object({
      vocabularySrs: z.object({
        state: z.enum(['full', 'reduced', 'off']),
        reason: z.string(),
        coverage: z.number().optional(),
      }),
      scenarios: z.object({
        state: z.enum(['full', 'reduced', 'off']),
        reason: z.string(),
        coverage: z.number().optional(),
      }),
      wordIpaDisplay: z.object({
        state: z.enum(['full', 'reduced', 'off']),
        reason: z.string(),
        coverage: z.number().optional(),
      }),
      wordPronunciationDrill: z.object({
        state: z.enum(['full', 'reduced', 'off']),
        reason: z.string(),
        coverage: z.number().optional(),
      }),
      pronunciationScore: z.object({
        state: z.enum(['full', 'reduced', 'off']),
        reason: z.string(),
        coverage: z.number().optional(),
      }),
      phonemeFeedback: z.object({
        state: z.enum(['full', 'reduced', 'off']),
        reason: z.string(),
        coverage: z.number().optional(),
      }),
      soundMapGuidance: z.object({
        state: z.enum(['full', 'reduced', 'off']),
        reason: z.string(),
        coverage: z.number().optional(),
      }),
      soundMapProgress: z.object({
        state: z.enum(['full', 'reduced', 'off']),
        reason: z.string(),
        coverage: z.number().optional(),
      }),
      competenceMap: z.object({
        state: z.enum(['full', 'reduced', 'off']),
        reason: z.string(),
        coverage: z.number().optional(),
      }),
      competenceProbes: z.object({
        state: z.enum(['full', 'reduced', 'off']),
        reason: z.string(),
        coverage: z.number().optional(),
      }),
    }),
  }).passthrough();
const _TargetCapabilitiesResponseStrict = z.object({
    sourceLocale: z.string(),
    targetLocale: z.string(),
    capabilities: z.object({
      vocabularySrs: z.object({
        state: z.enum(['full', 'reduced', 'off']),
        reason: z.string(),
        coverage: z.number().optional(),
      }),
      scenarios: z.object({
        state: z.enum(['full', 'reduced', 'off']),
        reason: z.string(),
        coverage: z.number().optional(),
      }),
      wordIpaDisplay: z.object({
        state: z.enum(['full', 'reduced', 'off']),
        reason: z.string(),
        coverage: z.number().optional(),
      }),
      wordPronunciationDrill: z.object({
        state: z.enum(['full', 'reduced', 'off']),
        reason: z.string(),
        coverage: z.number().optional(),
      }),
      pronunciationScore: z.object({
        state: z.enum(['full', 'reduced', 'off']),
        reason: z.string(),
        coverage: z.number().optional(),
      }),
      phonemeFeedback: z.object({
        state: z.enum(['full', 'reduced', 'off']),
        reason: z.string(),
        coverage: z.number().optional(),
      }),
      soundMapGuidance: z.object({
        state: z.enum(['full', 'reduced', 'off']),
        reason: z.string(),
        coverage: z.number().optional(),
      }),
      soundMapProgress: z.object({
        state: z.enum(['full', 'reduced', 'off']),
        reason: z.string(),
        coverage: z.number().optional(),
      }),
      competenceMap: z.object({
        state: z.enum(['full', 'reduced', 'off']),
        reason: z.string(),
        coverage: z.number().optional(),
      }),
      competenceProbes: z.object({
        state: z.enum(['full', 'reduced', 'off']),
        reason: z.string(),
        coverage: z.number().optional(),
      }),
    }),
  });
export type TargetCapabilitiesResponse = z.infer<typeof _TargetCapabilitiesResponseStrict>;

/** Per-set counts (VSET-009). Deliberately counts, not a percentage: "8/12" and "67%" are the same number, but only the first tells the learner how many words are left. Absence of a usage row means `new`, consistent with CMAP-001. */
export const VocabSetProgressSchema = z.object({
    total: z.number().int(),
    mastered: z.number().int(),
    learning: z.number().int(),
    new: z.number().int(),
  }).passthrough();
const _VocabSetProgressStrict = z.object({
    total: z.number().int(),
    mastered: z.number().int(),
    learning: z.number().int(),
    new: z.number().int(),
  });
export type VocabSetProgress = z.infer<typeof _VocabSetProgressStrict>;

/** One set as it appears in the list. */
export const VocabSetSummarySchema = z.object({
    slug: z.string(),
    title: z.record(z.string(), z.any()),
    description: z.record(z.string(), z.any()).optional(),
    emoji: z.string().optional(),
    sortOrder: z.number().int(),
    progress: z.object({
      total: z.number().int(),
      mastered: z.number().int(),
      learning: z.number().int(),
      new: z.number().int(),
    }),
  }).passthrough();
const _VocabSetSummaryStrict = z.object({
    slug: z.string(),
    title: z.record(z.string(), z.any()),
    description: z.record(z.string(), z.any()).optional(),
    emoji: z.string().optional(),
    sortOrder: z.number().int(),
    progress: z.object({
      total: z.number().int(),
      mastered: z.number().int(),
      learning: z.number().int(),
      new: z.number().int(),
    }),
  });
export type VocabSetSummary = z.infer<typeof _VocabSetSummaryStrict>;

/** GET /api/vocab/sets — the themed word sets for a course, with progress. Wrapped list, never a bare array (API_RESPONSE_SHAPES). */
export const VocabSetsResponseSchema = z.object({
    sets: z.array(z.object({
      slug: z.string(),
      title: z.record(z.string(), z.any()),
      description: z.record(z.string(), z.any()).optional(),
      emoji: z.string().optional(),
      sortOrder: z.number().int(),
      progress: z.object({
        total: z.number().int(),
        mastered: z.number().int(),
        learning: z.number().int(),
        new: z.number().int(),
      }),
    })),
  }).passthrough();
const _VocabSetsResponseStrict = z.object({
    sets: z.array(z.object({
      slug: z.string(),
      title: z.record(z.string(), z.any()),
      description: z.record(z.string(), z.any()).optional(),
      emoji: z.string().optional(),
      sortOrder: z.number().int(),
      progress: z.object({
        total: z.number().int(),
        mastered: z.number().int(),
        learning: z.number().int(),
        new: z.number().int(),
      }),
    })),
  });
export type VocabSetsResponse = z.infer<typeof _VocabSetsResponseStrict>;

/** One word in a set. `senseId` is the SAME sense a role play links, so mastery is the shared UserVocabUsage row (VSET-002) — there is no per-set progress. */
export const VocabSetMemberItemSchema = z.object({
    senseId: z.string(),
    lemma: z.string(),
    pos: z.string(),
    translation: z.record(z.string(), z.any()),
    ipa: z.string().optional(),
    ipaVariant: z.string().optional(),
    ipaIsFallback: z.boolean().optional(),
    status: z.enum(['new', 'learning', 'mastered']),
    sortOrder: z.number().int(),
  }).passthrough();
const _VocabSetMemberItemStrict = z.object({
    senseId: z.string(),
    lemma: z.string(),
    pos: z.string(),
    translation: z.record(z.string(), z.any()),
    ipa: z.string().optional(),
    ipaVariant: z.string().optional(),
    ipaIsFallback: z.boolean().optional(),
    status: z.enum(['new', 'learning', 'mastered']),
    sortOrder: z.number().int(),
  });
export type VocabSetMemberItem = z.infer<typeof _VocabSetMemberItemStrict>;

/** GET /api/vocab/sets/:slug — the set plus its ordered members. */
export const VocabSetDetailResponseSchema = z.object({
    set: z.object({
      slug: z.string(),
      title: z.record(z.string(), z.any()),
      description: z.record(z.string(), z.any()).optional(),
      emoji: z.string().optional(),
      sortOrder: z.number().int(),
      progress: z.object({
        total: z.number().int(),
        mastered: z.number().int(),
        learning: z.number().int(),
        new: z.number().int(),
      }),
    }),
    members: z.array(z.object({
      senseId: z.string(),
      lemma: z.string(),
      pos: z.string(),
      translation: z.record(z.string(), z.any()),
      ipa: z.string().optional(),
      ipaVariant: z.string().optional(),
      ipaIsFallback: z.boolean().optional(),
      status: z.enum(['new', 'learning', 'mastered']),
      sortOrder: z.number().int(),
    })),
  }).passthrough();
const _VocabSetDetailResponseStrict = z.object({
    set: z.object({
      slug: z.string(),
      title: z.record(z.string(), z.any()),
      description: z.record(z.string(), z.any()).optional(),
      emoji: z.string().optional(),
      sortOrder: z.number().int(),
      progress: z.object({
        total: z.number().int(),
        mastered: z.number().int(),
        learning: z.number().int(),
        new: z.number().int(),
      }),
    }),
    members: z.array(z.object({
      senseId: z.string(),
      lemma: z.string(),
      pos: z.string(),
      translation: z.record(z.string(), z.any()),
      ipa: z.string().optional(),
      ipaVariant: z.string().optional(),
      ipaIsFallback: z.boolean().optional(),
      status: z.enum(['new', 'learning', 'mastered']),
      sortOrder: z.number().int(),
    })),
  });
export type VocabSetDetailResponse = z.infer<typeof _VocabSetDetailResponseStrict>;

/** One drill result. `senseId` comes from GET /api/vocab/sets/:slug — the pair is resolved there, so this never re-resolves a surface form (resolving "red" would credit the headword's PRIMARY sense, i.e. the wrong meaning). */
export const VocabSetMarkRequestSchema = z.object({
    courseId: z.string(),
    senseId: z.string(),
    event: z.enum(['produced', 'encountered', 'struggled']),
  }).passthrough();
const _VocabSetMarkRequestStrict = z.object({
    courseId: z.string(),
    senseId: z.string(),
    event: z.enum(['produced', 'encountered', 'struggled']),
  });
export type VocabSetMarkRequest = z.infer<typeof _VocabSetMarkRequestStrict>;

/** The item's new shared mastery status after the mark. */
export const VocabSetMarkResponseSchema = z.object({
    senseId: z.string(),
    status: z.enum(['new', 'learning', 'mastered']),
  }).passthrough();
const _VocabSetMarkResponseStrict = z.object({
    senseId: z.string(),
    status: z.enum(['new', 'learning', 'mastered']),
  });
export type VocabSetMarkResponse = z.infer<typeof _VocabSetMarkResponseStrict>;

/** GET /api/vocab/summary response — one round-trip for the "Your vocabulary" screen and its hub entry card. */
export const VocabSummaryResponseSchema = z.object({
    vocab: z.object({
      new: z.number().int(),
      learning: z.number().int(),
      mastered: z.number().int(),
      due: z.number().int(),
    }),
    expressions: z.object({
      new: z.number().int(),
      learning: z.number().int(),
      mastered: z.number().int(),
      due: z.number().int(),
    }),
    assessedLevel: z.enum(['A1', 'A2', 'B1', 'B2', 'C1', 'C2']).optional(),
    byLevel: z.object({
      A1: z.object({
        total: z.number().int(),
        mastered: z.number().int(),
        learning: z.number().int(),
        new: z.number().int(),
        due: z.number().int(),
      }).optional(),
      A2: z.object({
        total: z.number().int(),
        mastered: z.number().int(),
        learning: z.number().int(),
        new: z.number().int(),
        due: z.number().int(),
      }).optional(),
      B1: z.object({
        total: z.number().int(),
        mastered: z.number().int(),
        learning: z.number().int(),
        new: z.number().int(),
        due: z.number().int(),
      }).optional(),
      B2: z.object({
        total: z.number().int(),
        mastered: z.number().int(),
        learning: z.number().int(),
        new: z.number().int(),
        due: z.number().int(),
      }).optional(),
      C1: z.object({
        total: z.number().int(),
        mastered: z.number().int(),
        learning: z.number().int(),
        new: z.number().int(),
        due: z.number().int(),
      }).optional(),
      C2: z.object({
        total: z.number().int(),
        mastered: z.number().int(),
        learning: z.number().int(),
        new: z.number().int(),
        due: z.number().int(),
      }).optional(),
    }).optional(),
  }).passthrough();
const _VocabSummaryResponseStrict = z.object({
    vocab: z.object({
      new: z.number().int(),
      learning: z.number().int(),
      mastered: z.number().int(),
      due: z.number().int(),
    }),
    expressions: z.object({
      new: z.number().int(),
      learning: z.number().int(),
      mastered: z.number().int(),
      due: z.number().int(),
    }),
    assessedLevel: z.enum(['A1', 'A2', 'B1', 'B2', 'C1', 'C2']).optional(),
    byLevel: z.object({
      A1: z.object({
        total: z.number().int(),
        mastered: z.number().int(),
        learning: z.number().int(),
        new: z.number().int(),
        due: z.number().int(),
      }).optional(),
      A2: z.object({
        total: z.number().int(),
        mastered: z.number().int(),
        learning: z.number().int(),
        new: z.number().int(),
        due: z.number().int(),
      }).optional(),
      B1: z.object({
        total: z.number().int(),
        mastered: z.number().int(),
        learning: z.number().int(),
        new: z.number().int(),
        due: z.number().int(),
      }).optional(),
      B2: z.object({
        total: z.number().int(),
        mastered: z.number().int(),
        learning: z.number().int(),
        new: z.number().int(),
        due: z.number().int(),
      }).optional(),
      C1: z.object({
        total: z.number().int(),
        mastered: z.number().int(),
        learning: z.number().int(),
        new: z.number().int(),
        due: z.number().int(),
      }).optional(),
      C2: z.object({
        total: z.number().int(),
        mastered: z.number().int(),
        learning: z.number().int(),
        new: z.number().int(),
        due: z.number().int(),
      }).optional(),
    }).optional(),
  });
export type VocabSummaryResponse = z.infer<typeof _VocabSummaryResponseStrict>;

/** GET /api/audio/series response (wrapped list) */
export const AudioSeriesListResponseSchema = z.object({
    series: z.array(z.object({
      slug: z.string(),
      kind: z.enum(['lesson_linked', 'standalone']),
      title: z.record(z.string(), z.any()),
      level: z.string().nullable(),
      sortOrder: z.number(),
      episodeCount: z.number(),
      completedCount: z.number(),
    })),
  }).passthrough();
const _AudioSeriesListResponseStrict = z.object({
    series: z.array(z.object({
      slug: z.string(),
      kind: z.enum(['lesson_linked', 'standalone']),
      title: z.record(z.string(), z.any()),
      level: z.string().nullable(),
      sortOrder: z.number(),
      episodeCount: z.number(),
      completedCount: z.number(),
    })),
  });
export type AudioSeriesListResponse = z.infer<typeof _AudioSeriesListResponseStrict>;

/** GET /api/audio/series/:slug response (composite series + episodes) */
export const AudioSeriesDetailResponseSchema = z.object({
    series: z.object({
      slug: z.string(),
      kind: z.enum(['lesson_linked', 'standalone']),
      title: z.record(z.string(), z.any()),
      level: z.string().nullable(),
      sortOrder: z.number(),
    }),
    episodes: z.array(z.object({
      slug: z.string(),
      title: z.record(z.string(), z.any()),
      grammarFocus: z.string(),
      lessonSlug: z.string().nullable(),
      sortOrder: z.number(),
      isPremium: z.boolean(),
      durationMs: z.number().nullable(),
    })),
  }).passthrough();
const _AudioSeriesDetailResponseStrict = z.object({
    series: z.object({
      slug: z.string(),
      kind: z.enum(['lesson_linked', 'standalone']),
      title: z.record(z.string(), z.any()),
      level: z.string().nullable(),
      sortOrder: z.number(),
    }),
    episodes: z.array(z.object({
      slug: z.string(),
      title: z.record(z.string(), z.any()),
      grammarFocus: z.string(),
      lessonSlug: z.string().nullable(),
      sortOrder: z.number(),
      isPremium: z.boolean(),
      durationMs: z.number().nullable(),
    })),
  });
export type AudioSeriesDetailResponse = z.infer<typeof _AudioSeriesDetailResponseStrict>;

/** GET /api/audio/episodes/:slug response (episode + one resolved rendition) */
export const AudioEpisodeDetailResponseSchema = z.object({
    episode: z.object({
      slug: z.string(),
      seriesSlug: z.string(),
      title: z.record(z.string(), z.any()),
      grammarFocus: z.string(),
      lessonSlug: z.string().nullable(),
      isPremium: z.boolean(),
      availableTeachingLanguages: z.array(z.enum(['source', 'target'])),
    }),
    rendition: z.object({
      teachingLanguage: z.enum(['source', 'target']),
      sourceLocale: z.string(),
      targetLocale: z.string(),
      audioUrl: z.string().nullable(),
      audioVersion: z.string(),
      durationMs: z.number(),
      voices: z.record(z.string(), z.any()),
      transcript: z.record(z.string(), z.any()),
    }),
  }).passthrough();
const _AudioEpisodeDetailResponseStrict = z.object({
    episode: z.object({
      slug: z.string(),
      seriesSlug: z.string(),
      title: z.record(z.string(), z.any()),
      grammarFocus: z.string(),
      lessonSlug: z.string().nullable(),
      isPremium: z.boolean(),
      availableTeachingLanguages: z.array(z.enum(['source', 'target'])),
    }),
    rendition: z.object({
      teachingLanguage: z.enum(['source', 'target']),
      sourceLocale: z.string(),
      targetLocale: z.string(),
      audioUrl: z.string().nullable(),
      audioVersion: z.string(),
      durationMs: z.number(),
      voices: z.record(z.string(), z.any()),
      transcript: z.record(z.string(), z.any()),
    }),
  });
export type AudioEpisodeDetailResponse = z.infer<typeof _AudioEpisodeDetailResponseStrict>;

/** POST /api/audio/episodes/:slug/progress response (success envelope) */
export const AudioProgressResponseSchema = z.object({
    success: z.boolean(),
    positionMs: z.number(),
    completed: z.boolean(),
  }).passthrough();
const _AudioProgressResponseStrict = z.object({
    success: z.boolean(),
    positionMs: z.number(),
    completed: z.boolean(),
  });
export type AudioProgressResponse = z.infer<typeof _AudioProgressResponseStrict>;

/** GET /api/audio/progress response (wrapped list of the caller's progress) */
export const AudioProgressListResponseSchema = z.object({
    progress: z.array(z.object({
      episodeSlug: z.string(),
      positionMs: z.number(),
      completed: z.boolean(),
      lastPlayedAt: z.string(),
    })),
  }).passthrough();
const _AudioProgressListResponseStrict = z.object({
    progress: z.array(z.object({
      episodeSlug: z.string(),
      positionMs: z.number(),
      completed: z.boolean(),
      lastPlayedAt: z.string(),
    })),
  });
export type AudioProgressListResponse = z.infer<typeof _AudioProgressListResponseStrict>;

/** GET /api/audio/episodes/by-lesson/:lessonSlug response (direct resource) */
export const AudioEpisodeByLessonResponseSchema = z.object({
    episodeSlug: z.string().nullable(),
  }).passthrough();
const _AudioEpisodeByLessonResponseStrict = z.object({
    episodeSlug: z.string().nullable(),
  });
export type AudioEpisodeByLessonResponse = z.infer<typeof _AudioEpisodeByLessonResponseStrict>;

/** POST /api/jobs/rollup-costs response */
export const CostRollupJobResponseSchema = z.object({
    success: z.boolean(),
    days: z.array(z.string()),
    dailyUserRows: z.number().int(),
    dailyGlobalRows: z.number().int(),
    summaryRows: z.number().int(),
    alerts: z.number().int(),
    prunedEvents: z.number().int(),
    durationMs: z.number().int(),
  }).passthrough();
const _CostRollupJobResponseStrict = z.object({
    success: z.boolean(),
    days: z.array(z.string()),
    dailyUserRows: z.number().int(),
    dailyGlobalRows: z.number().int(),
    summaryRows: z.number().int(),
    alerts: z.number().int(),
    prunedEvents: z.number().int(),
    durationMs: z.number().int(),
  });
export type CostRollupJobResponse = z.infer<typeof _CostRollupJobResponseStrict>;

/** POST /api/jobs/reconcile-speech response — Azure Monitor speech metric totals vs the CostEvent ledger for UTC yesterday. Log-only by default; alert rows require SPEECH_RECONCILIATION_ALERTS=true (see docs/specs/api/cost-metering.api.md §6).
 */
export const SpeechReconciliationJobResponseSchema = z.object({
    success: z.boolean(),
    skipped: z.boolean(),
    date: z.string(),
    alertingEnabled: z.boolean(),
    metrics: z.array(z.object({
      metric: z.enum(['azure_reconciliation_tts_characters', 'azure_reconciliation_stt_audio_seconds']),
      azureTotal: z.number(),
      ledgerTotal: z.number(),
      drift: z.number(),
      exceeded: z.boolean(),
    })),
    alerts: z.number().int(),
    durationMs: z.number().int(),
  }).passthrough();
const _SpeechReconciliationJobResponseStrict = z.object({
    success: z.boolean(),
    skipped: z.boolean(),
    date: z.string(),
    alertingEnabled: z.boolean(),
    metrics: z.array(z.object({
      metric: z.enum(['azure_reconciliation_tts_characters', 'azure_reconciliation_stt_audio_seconds']),
      azureTotal: z.number(),
      ledgerTotal: z.number(),
      drift: z.number(),
      exceeded: z.boolean(),
    })),
    alerts: z.number().int(),
    durationMs: z.number().int(),
  });
export type SpeechReconciliationJobResponse = z.infer<typeof _SpeechReconciliationJobResponseStrict>;

/** POST /api/jobs/reconcile-llm response — the LLM ledger's daily drift check (cost-metering spec §6b). `ledger` sizes the known-unreliable slices (estimated aborted-stream rows, pricing-miss rows) and always runs; the OpenAI Usage-API comparison requires OPENAI_ADMIN_API_KEY. Log-only by default; alert rows require LLM_RECONCILIATION_ALERTS=true.
 */
export const LlmReconciliationJobResponseSchema = z.object({
    success: z.boolean(),
    date: z.string(),
    alertingEnabled: z.boolean(),
    ledger: z.object({
      estimatedRows: z.number().int(),
      estimatedMicroUsd: z.number().int(),
      pricingMissRows: z.number().int(),
      pricingMissInputTokens: z.number().int(),
      pricingMissOutputTokens: z.number().int(),
    }),
    openaiSkipped: z.boolean(),
    metrics: z.array(z.object({
      metric: z.enum(['openai_reconciliation_input_tokens', 'openai_reconciliation_output_tokens']),
      providerTotal: z.number(),
      ledgerTotal: z.number(),
      drift: z.number(),
      exceeded: z.boolean(),
    })),
    geminiSkipped: z.boolean(),
    alerts: z.number().int(),
    durationMs: z.number().int(),
  }).passthrough();
const _LlmReconciliationJobResponseStrict = z.object({
    success: z.boolean(),
    date: z.string(),
    alertingEnabled: z.boolean(),
    ledger: z.object({
      estimatedRows: z.number().int(),
      estimatedMicroUsd: z.number().int(),
      pricingMissRows: z.number().int(),
      pricingMissInputTokens: z.number().int(),
      pricingMissOutputTokens: z.number().int(),
    }),
    openaiSkipped: z.boolean(),
    metrics: z.array(z.object({
      metric: z.enum(['openai_reconciliation_input_tokens', 'openai_reconciliation_output_tokens']),
      providerTotal: z.number(),
      ledgerTotal: z.number(),
      drift: z.number(),
      exceeded: z.boolean(),
    })),
    geminiSkipped: z.boolean(),
    alerts: z.number().int(),
    durationMs: z.number().int(),
  });
export type LlmReconciliationJobResponse = z.infer<typeof _LlmReconciliationJobResponseStrict>;

/** Cost subtotal for one CostEvent kind (llm | tts | pronunciation). */
export const CostKindTotalSchema = z.object({
    kind: z.string(),
    costMicroUsd: z.number().int(),
    eventCount: z.number().int(),
    audioSeconds: z.number().optional(),
  }).passthrough();
const _CostKindTotalStrict = z.object({
    kind: z.string(),
    costMicroUsd: z.number().int(),
    eventCount: z.number().int(),
    audioSeconds: z.number().optional(),
  });
export type CostKindTotal = z.infer<typeof _CostKindTotalStrict>;

/** One raw cost_events row of a conversation — the itemized-ledger unit of the session drill-down. Field presence follows the seam that wrote the row: LLM steps carry model/tokens/stepIndex/finishReason/toolNames, TTS rows carry voice/characters, speech-relay rows carry audioSeconds. Absent fields are omitted, never null.
 */
export const SessionCostEventSchema = z.object({
    id: z.string(),
    kind: z.string(),
    costMicroUsd: z.number().int(),
    createdAt: z.string(),
    messageId: z.string().optional(),
    flowType: z.string().optional(),
    operation: z.string().optional(),
    provider: z.string().optional(),
    model: z.string().optional(),
    inputTokens: z.number().int().optional(),
    cachedInputTokens: z.number().int().optional(),
    outputTokens: z.number().int().optional(),
    stepIndex: z.number().int().optional(),
    finishReason: z.string().optional(),
    toolNames: z.array(z.string()).optional(),
    voice: z.string().optional(),
    characters: z.number().int().optional(),
    audioSeconds: z.number().optional(),
    latencyMs: z.number().int().optional(),
    ttftMs: z.number().int().optional(),
  }).passthrough();
const _SessionCostEventStrict = z.object({
    id: z.string(),
    kind: z.string(),
    costMicroUsd: z.number().int(),
    createdAt: z.string(),
    messageId: z.string().optional(),
    flowType: z.string().optional(),
    operation: z.string().optional(),
    provider: z.string().optional(),
    model: z.string().optional(),
    inputTokens: z.number().int().optional(),
    cachedInputTokens: z.number().int().optional(),
    outputTokens: z.number().int().optional(),
    stepIndex: z.number().int().optional(),
    finishReason: z.string().optional(),
    toolNames: z.array(z.string()).optional(),
    voice: z.string().optional(),
    characters: z.number().int().optional(),
    audioSeconds: z.number().optional(),
    latencyMs: z.number().int().optional(),
    ttftMs: z.number().int().optional(),
  });
export type SessionCostEvent = z.infer<typeof _SessionCostEventStrict>;

/** GET /api/admin/costs/session/:sessionId response — what one conversation cost, read from RAW cost_events (ADR-026). Every row for the session lands in exactly one of `interactions` (rows carrying a message id belonging to this session) or `sessionLevel` (rows attributed to the session but to no single message), so `totalMicroUsd` is the sum of both and nothing is double-counted. `events` is the same set of rows, itemized.
 */
export const AdminSessionCostsResponseSchema = z.object({
    sessionId: z.string(),
    userId: z.string(),
    flowType: z.string().optional(),
    createdAt: z.string().optional(),
    totalMicroUsd: z.number().int(),
    retentionDays: z.number().int(),
    truncated: z.boolean(),
    byKind: z.array(z.object({
      kind: z.string(),
      costMicroUsd: z.number().int(),
      eventCount: z.number().int(),
      audioSeconds: z.number().optional(),
    })),
    interactions: z.array(z.object({
      messageId: z.string(),
      role: z.string().optional(),
      createdAt: z.string().optional(),
      costMicroUsd: z.number().int(),
      eventCount: z.number().int(),
      byKind: z.array(z.object({
        kind: z.string(),
        costMicroUsd: z.number().int(),
        eventCount: z.number().int(),
        audioSeconds: z.number().optional(),
      })),
    })),
    sessionLevel: z.array(z.object({
      kind: z.string(),
      costMicroUsd: z.number().int(),
      eventCount: z.number().int(),
      audioSeconds: z.number().optional(),
    })),
    events: z.array(z.object({
      id: z.string(),
      kind: z.string(),
      costMicroUsd: z.number().int(),
      createdAt: z.string(),
      messageId: z.string().optional(),
      flowType: z.string().optional(),
      operation: z.string().optional(),
      provider: z.string().optional(),
      model: z.string().optional(),
      inputTokens: z.number().int().optional(),
      cachedInputTokens: z.number().int().optional(),
      outputTokens: z.number().int().optional(),
      stepIndex: z.number().int().optional(),
      finishReason: z.string().optional(),
      toolNames: z.array(z.string()).optional(),
      voice: z.string().optional(),
      characters: z.number().int().optional(),
      audioSeconds: z.number().optional(),
      latencyMs: z.number().int().optional(),
      ttftMs: z.number().int().optional(),
    })),
  }).passthrough();
const _AdminSessionCostsResponseStrict = z.object({
    sessionId: z.string(),
    userId: z.string(),
    flowType: z.string().optional(),
    createdAt: z.string().optional(),
    totalMicroUsd: z.number().int(),
    retentionDays: z.number().int(),
    truncated: z.boolean(),
    byKind: z.array(z.object({
      kind: z.string(),
      costMicroUsd: z.number().int(),
      eventCount: z.number().int(),
      audioSeconds: z.number().optional(),
    })),
    interactions: z.array(z.object({
      messageId: z.string(),
      role: z.string().optional(),
      createdAt: z.string().optional(),
      costMicroUsd: z.number().int(),
      eventCount: z.number().int(),
      byKind: z.array(z.object({
        kind: z.string(),
        costMicroUsd: z.number().int(),
        eventCount: z.number().int(),
        audioSeconds: z.number().optional(),
      })),
    })),
    sessionLevel: z.array(z.object({
      kind: z.string(),
      costMicroUsd: z.number().int(),
      eventCount: z.number().int(),
      audioSeconds: z.number().optional(),
    })),
    events: z.array(z.object({
      id: z.string(),
      kind: z.string(),
      costMicroUsd: z.number().int(),
      createdAt: z.string(),
      messageId: z.string().optional(),
      flowType: z.string().optional(),
      operation: z.string().optional(),
      provider: z.string().optional(),
      model: z.string().optional(),
      inputTokens: z.number().int().optional(),
      cachedInputTokens: z.number().int().optional(),
      outputTokens: z.number().int().optional(),
      stepIndex: z.number().int().optional(),
      finishReason: z.string().optional(),
      toolNames: z.array(z.string()).optional(),
      voice: z.string().optional(),
      characters: z.number().int().optional(),
      audioSeconds: z.number().optional(),
      latencyMs: z.number().int().optional(),
      ttftMs: z.number().int().optional(),
    })),
  });
export type AdminSessionCostsResponse = z.infer<typeof _AdminSessionCostsResponseStrict>;

/** GET /api/admin/costs response — pre-aggregated rollups for a date range */
export const AdminCostsResponseSchema = z.object({
    environment: z.string(),
    from: z.string(),
    to: z.string(),
    scope: z.enum(['global', 'user']),
    totalMicroUsd: z.number().int(),
    global: z.array(z.object({
      date: z.string(),
      kind: z.string(),
      provider: z.string().optional(),
      model: z.string().optional(),
      voice: z.string().optional(),
      region: z.string().optional(),
      costMicroUsd: z.number().int(),
      eventCount: z.number().int(),
      activeUsers: z.number().int(),
    })),
    summary: z.array(z.object({
      date: z.string(),
      totalMicroUsd: z.number().int(),
      activeUsers: z.number().int(),
      meanPerUserMicroUsd: z.number().int(),
      medianPerUserMicroUsd: z.number().int(),
      p90PerUserMicroUsd: z.number().int(),
      p99PerUserMicroUsd: z.number().int(),
    })),
    users: z.array(z.object({
      date: z.string(),
      userId: z.string(),
      kind: z.string(),
      flowType: z.string().optional(),
      model: z.string().optional(),
      voice: z.string().optional(),
      region: z.string().optional(),
      costMicroUsd: z.number().int(),
      eventCount: z.number().int(),
    })).optional(),
  }).passthrough();
const _AdminCostsResponseStrict = z.object({
    environment: z.string(),
    from: z.string(),
    to: z.string(),
    scope: z.enum(['global', 'user']),
    totalMicroUsd: z.number().int(),
    global: z.array(z.object({
      date: z.string(),
      kind: z.string(),
      provider: z.string().optional(),
      model: z.string().optional(),
      voice: z.string().optional(),
      region: z.string().optional(),
      costMicroUsd: z.number().int(),
      eventCount: z.number().int(),
      activeUsers: z.number().int(),
    })),
    summary: z.array(z.object({
      date: z.string(),
      totalMicroUsd: z.number().int(),
      activeUsers: z.number().int(),
      meanPerUserMicroUsd: z.number().int(),
      medianPerUserMicroUsd: z.number().int(),
      p90PerUserMicroUsd: z.number().int(),
      p99PerUserMicroUsd: z.number().int(),
    })),
    users: z.array(z.object({
      date: z.string(),
      userId: z.string(),
      kind: z.string(),
      flowType: z.string().optional(),
      model: z.string().optional(),
      voice: z.string().optional(),
      region: z.string().optional(),
      costMicroUsd: z.number().int(),
      eventCount: z.number().int(),
    })).optional(),
  });
export type AdminCostsResponse = z.infer<typeof _AdminCostsResponseStrict>;

/** One target-language phoneme with the learner's mastery state and the variant-resolved contrastive difficulty as a priority hint. `state` is computed server-side (docs/specs/api/sound-map.api.md) — clients render, they do not re-derive thresholds.
 */
export const SoundMapPhonemeSchema = z.object({
    ipaSymbol: z.string(),
    label: z.string(),
    type: z.enum(['consonant', 'vowel', 'diphthong', 'tone']),
    exampleWords: z.array(z.string()),
    difficulty: z.number().int().min(1).max(5).nullable(),
    contrastiveNote: z.string().nullable().optional(),
    teachingTips: z.array(z.string()).optional(),
    state: z.enum(['mastered', 'learning', 'weak', 'untried']),
    avgScore: z.number().nullable(),
    attempts: z.number().int(),
    lastPracticedAt: z.string().nullable(),
  }).passthrough();
const _SoundMapPhonemeStrict = z.object({
    ipaSymbol: z.string(),
    label: z.string(),
    type: z.enum(['consonant', 'vowel', 'diphthong', 'tone']),
    exampleWords: z.array(z.string()),
    difficulty: z.number().int().min(1).max(5).nullable(),
    contrastiveNote: z.string().nullable().optional(),
    teachingTips: z.array(z.string()).optional(),
    state: z.enum(['mastered', 'learning', 'weak', 'untried']),
    avgScore: z.number().nullable(),
    attempts: z.number().int(),
    lastPracticedAt: z.string().nullable(),
  });
export type SoundMapPhoneme = z.infer<typeof _SoundMapPhonemeStrict>;

/** GET /api/speech/sound-map response — the learner's per-phoneme mastery map over the full target-language inventory, ordered consonants → vowels → diphthongs. Locales resolve from the freshest course preference (same "active course" proxy as server TTS voice resolution), falling back to the latest session, then the first lesson-bearing course.
 */
export const SoundMapResponseSchema = z.object({
    sourceLocale: z.string(),
    targetLocale: z.string(),
    resolvedDifficultyPair: z.object({
      source: z.string(),
      target: z.string(),
    }).nullable(),
    summary: z.object({
      mastered: z.number().int(),
      learning: z.number().int(),
      weak: z.number().int(),
      untried: z.number().int(),
    }),
    phonemes: z.array(z.object({
      ipaSymbol: z.string(),
      label: z.string(),
      type: z.enum(['consonant', 'vowel', 'diphthong', 'tone']),
      exampleWords: z.array(z.string()),
      difficulty: z.number().int().min(1).max(5).nullable(),
      contrastiveNote: z.string().nullable().optional(),
      teachingTips: z.array(z.string()).optional(),
      state: z.enum(['mastered', 'learning', 'weak', 'untried']),
      avgScore: z.number().nullable(),
      attempts: z.number().int(),
      lastPracticedAt: z.string().nullable(),
    })),
    capabilities: z.object({
      guidance: z.enum(['full', 'off']),
      progress: z.enum(['full', 'off']),
      progressBlockedReason: z.string().optional(),
    }).optional(),
  }).passthrough();
const _SoundMapResponseStrict = z.object({
    sourceLocale: z.string(),
    targetLocale: z.string(),
    resolvedDifficultyPair: z.object({
      source: z.string(),
      target: z.string(),
    }).nullable(),
    summary: z.object({
      mastered: z.number().int(),
      learning: z.number().int(),
      weak: z.number().int(),
      untried: z.number().int(),
    }),
    phonemes: z.array(z.object({
      ipaSymbol: z.string(),
      label: z.string(),
      type: z.enum(['consonant', 'vowel', 'diphthong', 'tone']),
      exampleWords: z.array(z.string()),
      difficulty: z.number().int().min(1).max(5).nullable(),
      contrastiveNote: z.string().nullable().optional(),
      teachingTips: z.array(z.string()).optional(),
      state: z.enum(['mastered', 'learning', 'weak', 'untried']),
      avgScore: z.number().nullable(),
      attempts: z.number().int(),
      lastPracticedAt: z.string().nullable(),
    })),
    capabilities: z.object({
      guidance: z.enum(['full', 'off']),
      progress: z.enum(['full', 'off']),
      progressBlockedReason: z.string().optional(),
    }).optional(),
  });
export type SoundMapResponse = z.infer<typeof _SoundMapResponseStrict>;

/** One correct/incorrect pair for a competence, from the seeded inventory. */
export const CompetenceMapExampleSchema = z.object({
    correct: z.string(),
    incorrect: z.string().optional(),
    note: z.string().optional(),
  }).passthrough();
const _CompetenceMapExampleStrict = z.object({
    correct: z.string(),
    incorrect: z.string().optional(),
    note: z.string().optional(),
  });
export type CompetenceMapExample = z.infer<typeof _CompetenceMapExampleStrict>;

/** One grammar competence with the learner's mastery state and the variant-resolved contrastive difficulty as a priority hint. `state` is computed server-side (docs/specs/api/competence-map.api.md) — clients render, they do not re-derive thresholds. `upcoming` means the competence sits above the learner's assessed level and has no evidence yet: NOT a gap (CMAP-001).
 */
export const CompetenceMapItemSchema = z.object({
    slug: z.string(),
    label: z.string(),
    category: z.enum(['verb', 'noun_determiner', 'pronoun', 'modifier', 'syntax', 'lexis', 'discourse', 'mechanics', 'other']),
    cefrLevel: z.enum(['A1', 'A2', 'B1', 'B2', 'C1', 'C2']).nullable(),
    canDoStatement: z.string().nullable(),
    examples: z.array(z.object({
      correct: z.string(),
      incorrect: z.string().optional(),
      note: z.string().optional(),
    })),
    difficulty: z.number().int().min(1).max(5).nullable(),
    interferenceType: z.enum(['identical', 'similar', 'divergent', 'absent']).nullable(),
    contrastiveNote: z.string().nullable(),
    teachingTips: z.array(z.string()),
    state: z.enum(['mastered', 'learning', 'struggling', 'untried', 'upcoming']),
    productions: z.number().int(),
    struggles: z.number().int(),
    sessionsCount: z.number().int(),
    lastUsedAt: z.string().nullable(),
    dueAt: z.string().nullable(),
    isDue: z.boolean(),
  }).passthrough();
const _CompetenceMapItemStrict = z.object({
    slug: z.string(),
    label: z.string(),
    category: z.enum(['verb', 'noun_determiner', 'pronoun', 'modifier', 'syntax', 'lexis', 'discourse', 'mechanics', 'other']),
    cefrLevel: z.enum(['A1', 'A2', 'B1', 'B2', 'C1', 'C2']).nullable(),
    canDoStatement: z.string().nullable(),
    examples: z.array(z.object({
      correct: z.string(),
      incorrect: z.string().optional(),
      note: z.string().optional(),
    })),
    difficulty: z.number().int().min(1).max(5).nullable(),
    interferenceType: z.enum(['identical', 'similar', 'divergent', 'absent']).nullable(),
    contrastiveNote: z.string().nullable(),
    teachingTips: z.array(z.string()),
    state: z.enum(['mastered', 'learning', 'struggling', 'untried', 'upcoming']),
    productions: z.number().int(),
    struggles: z.number().int(),
    sessionsCount: z.number().int(),
    lastUsedAt: z.string().nullable(),
    dueAt: z.string().nullable(),
    isDue: z.boolean(),
  });
export type CompetenceMapItem = z.infer<typeof _CompetenceMapItemStrict>;

/** GET /api/grammar/competence-map response — the learner's mastery map over the full closed competence taxonomy (all 62, including the six with no lesson mapped: this list, not GET /api/lessons/recommended, is what the focus picker reads). Ordered CEFR band A1 → C2 (null-level last), then category order, then slug. Locales resolve exactly as the Sound Map's do.
 */
export const CompetenceMapResponseSchema = z.object({
    sourceLocale: z.string(),
    targetLocale: z.string(),
    assessedLevel: z.enum(['A1', 'A2', 'B1', 'B2', 'C1', 'C2']),
    resolvedDifficultyPair: z.object({
      source: z.string(),
      target: z.string(),
    }).nullable(),
    summary: z.object({
      mastered: z.number().int(),
      learning: z.number().int(),
      struggling: z.number().int(),
      untried: z.number().int(),
      upcoming: z.number().int(),
      due: z.number().int(),
    }),
    competences: z.array(z.object({
      slug: z.string(),
      label: z.string(),
      category: z.enum(['verb', 'noun_determiner', 'pronoun', 'modifier', 'syntax', 'lexis', 'discourse', 'mechanics', 'other']),
      cefrLevel: z.enum(['A1', 'A2', 'B1', 'B2', 'C1', 'C2']).nullable(),
      canDoStatement: z.string().nullable(),
      examples: z.array(z.object({
        correct: z.string(),
        incorrect: z.string().optional(),
        note: z.string().optional(),
      })),
      difficulty: z.number().int().min(1).max(5).nullable(),
      interferenceType: z.enum(['identical', 'similar', 'divergent', 'absent']).nullable(),
      contrastiveNote: z.string().nullable(),
      teachingTips: z.array(z.string()),
      state: z.enum(['mastered', 'learning', 'struggling', 'untried', 'upcoming']),
      productions: z.number().int(),
      struggles: z.number().int(),
      sessionsCount: z.number().int(),
      lastUsedAt: z.string().nullable(),
      dueAt: z.string().nullable(),
      isDue: z.boolean(),
    })),
  }).passthrough();
const _CompetenceMapResponseStrict = z.object({
    sourceLocale: z.string(),
    targetLocale: z.string(),
    assessedLevel: z.enum(['A1', 'A2', 'B1', 'B2', 'C1', 'C2']),
    resolvedDifficultyPair: z.object({
      source: z.string(),
      target: z.string(),
    }).nullable(),
    summary: z.object({
      mastered: z.number().int(),
      learning: z.number().int(),
      struggling: z.number().int(),
      untried: z.number().int(),
      upcoming: z.number().int(),
      due: z.number().int(),
    }),
    competences: z.array(z.object({
      slug: z.string(),
      label: z.string(),
      category: z.enum(['verb', 'noun_determiner', 'pronoun', 'modifier', 'syntax', 'lexis', 'discourse', 'mechanics', 'other']),
      cefrLevel: z.enum(['A1', 'A2', 'B1', 'B2', 'C1', 'C2']).nullable(),
      canDoStatement: z.string().nullable(),
      examples: z.array(z.object({
        correct: z.string(),
        incorrect: z.string().optional(),
        note: z.string().optional(),
      })),
      difficulty: z.number().int().min(1).max(5).nullable(),
      interferenceType: z.enum(['identical', 'similar', 'divergent', 'absent']).nullable(),
      contrastiveNote: z.string().nullable(),
      teachingTips: z.array(z.string()),
      state: z.enum(['mastered', 'learning', 'struggling', 'untried', 'upcoming']),
      productions: z.number().int(),
      struggles: z.number().int(),
      sessionsCount: z.number().int(),
      lastUsedAt: z.string().nullable(),
      dueAt: z.string().nullable(),
      isDue: z.boolean(),
    })),
  });
export type CompetenceMapResponse = z.infer<typeof _CompetenceMapResponseStrict>;

/** HTTP response schemas keyed by name — for runtime validation */
export const HttpResponseSchemas = {
  ApiErrorResponse: ApiErrorResponseSchema,
  SuccessEnvelope: SuccessEnvelopeSchema,
  Subscription: SubscriptionSchema,
  UserProfile: UserProfileSchema,
  ConversationMessage: ConversationMessageSchema,
  SessionSummary: SessionSummarySchema,
  DevRoleplayStartResponse: DevRoleplayStartResponseSchema,
  DevTestUser: DevTestUserSchema,
  DevTestUserListResponse: DevTestUserListResponseSchema,
  DevTestUserOtpResponse: DevTestUserOtpResponseSchema,
  DevTestUserCleanupResponse: DevTestUserCleanupResponseSchema,
  DevRoleplayTurn: DevRoleplayTurnSchema,
  SessionMessagesResponse: SessionMessagesResponseSchema,
  SendMessageResponse: SendMessageResponseSchema,
  AnalyzeResponse: AnalyzeResponseSchema,
  LessonSummary: LessonSummarySchema,
  LessonPathResponse: LessonPathResponseSchema,
  ScheduledLessonsResponse: ScheduledLessonsResponseSchema,
  LessonListResponse: LessonListResponseSchema,
  LessonRecommendedResponse: LessonRecommendedResponseSchema,
  LessonIndexResponse: LessonIndexResponseSchema,
  LessonDetailResponse: LessonDetailResponseSchema,
  LessonCompleteResponse: LessonCompleteResponseSchema,
  LessonSearchResponse: LessonSearchResponseSchema,
  GenerateLessonResponse: GenerateLessonResponseSchema,
  LessonDraftResponse: LessonDraftResponseSchema,
  LessonHistoryResponse: LessonHistoryResponseSchema,
  ExerciseGenerationResponse: ExerciseGenerationResponseSchema,
  QuickPracticeResponse: QuickPracticeResponseSchema,
  DeletionStatusResponse: DeletionStatusResponseSchema,
  ReportCreateResponse: ReportCreateResponseSchema,
  NativeLocaleInfo: NativeLocaleInfoSchema,
  AzureVoice: AzureVoiceSchema,
  PronunciationFeatures: PronunciationFeaturesSchema,
  AzureSpeechConfig: AzureSpeechConfigSchema,
  LanguageCapabilities: LanguageCapabilitiesSchema,
  LocaleMetadata: LocaleMetadataSchema,
  LanguageCourse: LanguageCourseSchema,
  CountryConfig: CountryConfigSchema,
  CoursesResponse: CoursesResponseSchema,
  RequestDeletionResponse: RequestDeletionResponseSchema,
  CancelDeletionResponse: CancelDeletionResponseSchema,
  DeletionJobResponse: DeletionJobResponseSchema,
  ReconciliationBatchResponse: ReconciliationBatchResponseSchema,
  ReconciliationFullResponse: ReconciliationFullResponseSchema,
  PromptsReloadResponse: PromptsReloadResponseSchema,
  AdminMessageItem: AdminMessageItemSchema,
  AdminMessageResponse: AdminMessageResponseSchema,
  AdminMessageListResponse: AdminMessageListResponseSchema,
  HealthResponse: HealthResponseSchema,
  ConfigResponse: ConfigResponseSchema,
  SessionListResponse: SessionListResponseSchema,
  MyReportsResponse: MyReportsResponseSchema,
  CheckLessonUpdatesResponse: CheckLessonUpdatesResponseSchema,
  InAppMessagePayload: InAppMessagePayloadSchema,
  ActiveMessagesResponse: ActiveMessagesResponseSchema,
  RolePlaySlotSummary: RolePlaySlotSummarySchema,
  RolePlaySlotDetail: RolePlaySlotDetailSchema,
  RolePlaySlotListResponse: RolePlaySlotListResponseSchema,
  RolePlaySlotDetailResponse: RolePlaySlotDetailResponseSchema,
  RolePlayTemplateSummary: RolePlayTemplateSummarySchema,
  RolePlayVocabularyItem: RolePlayVocabularyItemSchema,
  RolePlayPhraseItem: RolePlayPhraseItemSchema,
  RolePlayTemplateDetail: RolePlayTemplateDetailSchema,
  RolePlayTemplateListResponse: RolePlayTemplateListResponseSchema,
  RolePlayTemplateDetailResponse: RolePlayTemplateDetailResponseSchema,
  LearnerStatus: LearnerStatusSchema,
  CEFRLevel: CEFRLevelSchema,
  RolePlayCollectionSummary: RolePlayCollectionSummarySchema,
  RolePlayCollectionDetail: RolePlayCollectionDetailSchema,
  RolePlayCollectionListResponse: RolePlayCollectionListResponseSchema,
  RolePlayCollectionDetailResponse: RolePlayCollectionDetailResponseSchema,
  RolePlayCatalogVocab: RolePlayCatalogVocabSchema,
  RolePlayCatalogExpression: RolePlayCatalogExpressionSchema,
  VocabItemSummary: VocabItemSummarySchema,
  VocabItemDetail: VocabItemDetailSchema,
  VocabItemListResponse: VocabItemListResponseSchema,
  VocabItemDetailResponse: VocabItemDetailResponseSchema,
  ExpressionItemSummary: ExpressionItemSummarySchema,
  ExpressionItemDetail: ExpressionItemDetailSchema,
  ExpressionItemListResponse: ExpressionItemListResponseSchema,
  ExpressionItemDetailResponse: ExpressionItemDetailResponseSchema,
  VocabStatusCounts: VocabStatusCountsSchema,
  VocabLevelCounts: VocabLevelCountsSchema,
  TargetCapability: TargetCapabilitySchema,
  TargetCapabilities: TargetCapabilitiesSchema,
  TargetCapabilitiesResponse: TargetCapabilitiesResponseSchema,
  VocabSetProgress: VocabSetProgressSchema,
  VocabSetSummary: VocabSetSummarySchema,
  VocabSetsResponse: VocabSetsResponseSchema,
  VocabSetMemberItem: VocabSetMemberItemSchema,
  VocabSetDetailResponse: VocabSetDetailResponseSchema,
  VocabSetMarkRequest: VocabSetMarkRequestSchema,
  VocabSetMarkResponse: VocabSetMarkResponseSchema,
  VocabSummaryResponse: VocabSummaryResponseSchema,
  AudioSeriesListResponse: AudioSeriesListResponseSchema,
  AudioSeriesDetailResponse: AudioSeriesDetailResponseSchema,
  AudioEpisodeDetailResponse: AudioEpisodeDetailResponseSchema,
  AudioProgressResponse: AudioProgressResponseSchema,
  AudioProgressListResponse: AudioProgressListResponseSchema,
  AudioEpisodeByLessonResponse: AudioEpisodeByLessonResponseSchema,
  CostRollupJobResponse: CostRollupJobResponseSchema,
  SpeechReconciliationJobResponse: SpeechReconciliationJobResponseSchema,
  LlmReconciliationJobResponse: LlmReconciliationJobResponseSchema,
  CostKindTotal: CostKindTotalSchema,
  SessionCostEvent: SessionCostEventSchema,
  AdminSessionCostsResponse: AdminSessionCostsResponseSchema,
  AdminCostsResponse: AdminCostsResponseSchema,
  SoundMapPhoneme: SoundMapPhonemeSchema,
  SoundMapResponse: SoundMapResponseSchema,
  CompetenceMapExample: CompetenceMapExampleSchema,
  CompetenceMapItem: CompetenceMapItemSchema,
  CompetenceMapResponse: CompetenceMapResponseSchema,
} as const;

// ══════════════════════════════════════════════════════════════
// Request Schemas
// ══════════════════════════════════════════════════════════════

/** POST /api/user/sync request body */
export const SyncUserRequestSchema = z.object({
    onboardingCompleted: z.boolean().optional(),
    aiConsent: z.object({
      granted: z.boolean(),
      version: z.number().int().min(1),
    }).optional(),
  });
export type SyncUserRequest = z.infer<typeof SyncUserRequestSchema>;

/** PATCH /api/user/preferences request body (at least one field required) */
export const UpdatePreferencesRequestSchema = z.object({
    displayName: z.string().min(1).max(50).optional(),
    voiceExercisesEnabled: z.boolean().optional(),
    debugContextSnapshots: z.boolean().optional(),
    lessonFeedbackEnabled: z.boolean().optional(),
    coursePreferences: z.array(z.object({
      courseId: z.string(),
      country: z.string().min(2).max(2),
      sourceLocale: z.string(),
      targetLocale: z.string(),
      lessonLanguage: z.enum(['source', 'target']),
      azureTtsVoice: z.string(),
      ttsProvider: z.enum(['device', 'azure-server']),
      sttProvider: z.enum(['device', 'azure']),
    })).optional(),
  });
export type UpdatePreferencesRequest = z.infer<typeof UpdatePreferencesRequestSchema>;

/** PATCH /api/user/course-preferences request body */
export const UpdateCoursePreferenceRequestSchema = z.object({
    courseId: z.string(),
    sourceLocale: z.string(),
    targetLocale: z.string(),
    lessonLanguage: z.enum(['source', 'target']),
    azureTtsVoice: z.string(),
    ttsProvider: z.enum(['device', 'azure-server']),
    sttProvider: z.enum(['device', 'azure']),
  });
export type UpdateCoursePreferenceRequest = z.infer<typeof UpdateCoursePreferenceRequestSchema>;

/** POST /api/conversation/sessions request body */
export const CreateSessionRequestSchema = z.object({
    flowType: z.string(),
    courseId: z.string(),
    sourceLocale: z.string(),
    targetLocale: z.string(),
    focusPhoneme: z.string().min(1).max(8).regex(new RegExp('^\\S+$')).optional(),
    focusGrammarPoint: z.string().min(1).max(60).regex(new RegExp('^\\S+$')).optional(),
  });
export type CreateSessionRequest = z.infer<typeof CreateSessionRequestSchema>;

/** POST /api/lessons/:slug/complete request body */
export const LessonCompleteRequestSchema = z.object({
    score: z.number().int().min(0).max(100),
    exerciseResults: z.record(z.string(), z.any()).default({}),
  });
export type LessonCompleteRequest = z.infer<typeof LessonCompleteRequestSchema>;

/** POST /api/lessons/search request body */
export const LessonSearchRequestSchema = z.object({
    keywords: z.array(z.string().min(1)).min(1).max(20),
    level: z.string().optional(),
    category: z.string().optional(),
    limit: z.number().int().min(1).max(50).default(10),
    excludeSlugs: z.array(z.string()).default([]),
  });
export type LessonSearchRequest = z.infer<typeof LessonSearchRequestSchema>;

/** POST /api/lessons/ai-search request body */
export const AiSearchRequestSchema = z.object({
    errorContext: z.object({
      original: z.string().min(1).max(500),
      correction: z.string().min(1).max(500),
      explanation: z.string().min(1).max(1000),
      type: z.string().optional(),
    }),
    userLevel: z.string().optional(),
    limit: z.number().int().min(1).max(10).default(5),
  });
export type AiSearchRequest = z.infer<typeof AiSearchRequestSchema>;

/** POST /api/lessons/generate request body */
export const GenerateLessonRequestSchema = z.object({
    courseId: z.string(),
    errorType: z.string().min(1),
    errorContext: z.object({
      originalText: z.string().min(1),
      error: z.string().min(1),
      correction: z.string().min(1),
      explanation: z.string().optional(),
    }),
  });
export type GenerateLessonRequest = z.infer<typeof GenerateLessonRequestSchema>;

/** POST /api/lessons/:slug/generate-exercises request body */
export const ExerciseGenerationRequestSchema = z.object({
    courseId: z.string(),
    aiAgentInstructions: z.object({
      count: z.number().int().min(1).max(20),
      exerciseTypes: z.array(z.string().min(1)).min(1).max(10),
      topic: z.string().min(1).max(500),
      level: z.string().min(1).max(10),
      constraints: z.string().max(1000).default(''),
      personalize: z.boolean().default(false),
      freshOnEveryVisit: z.boolean().default(false),
    }),
  });
export type ExerciseGenerationRequest = z.infer<typeof ExerciseGenerationRequestSchema>;

/** POST /api/lessons/quick-practice request body */
export const QuickPracticeRequestSchema = z.object({
    courseId: z.string(),
    messageId: z.string().uuid(),
    errorType: z.string().min(1).max(100),
    original: z.string().min(1).max(500),
    correction: z.string().min(1).max(500),
    explanation: z.string().min(1).max(1000),
  });
export type QuickPracticeRequest = z.infer<typeof QuickPracticeRequestSchema>;

/** POST /api/lessons/feedback request body */
export const SubmitFeedbackRequestSchema = z.object({
    lessonId: z.string().uuid(),
    sectionIndex: z.number().int().min(0).optional(),
    locale: z.string().regex(new RegExp('^[a-z]{2}-[A-Za-z0-9]{2,4}$')),
    text: z.string().min(1).max(2000),
  });
export type SubmitFeedbackRequest = z.infer<typeof SubmitFeedbackRequestSchema>;

/** POST /api/reports/ai-content request body */
export const ReportAIContentRequestSchema = z.object({
    messageId: z.string().min(1),
    messageText: z.string().max(2000).optional(),
    aiProvider: z.string().max(100).optional(),
    reportReason: z.string().max(500).optional(),
    analysisData: z.record(z.string(), z.any()).optional(),
  });
export type ReportAIContentRequest = z.infer<typeof ReportAIContentRequestSchema>;

/** POST /api/account/request-deletion request body */
export const RequestDeletionRequestSchema = z.object({
    reason: z.string().optional(),
  });
export type RequestDeletionRequest = z.infer<typeof RequestDeletionRequestSchema>;

/** POST /api/speech/tts request body */
export const SpeechTtsRequestSchema = z.object({
    text: z.string().min(1).max(800),
    voice: z.string().min(1).max(100).regex(new RegExp('^[A-Za-z0-9:-]+$')).optional(),
    messageId: z.string().max(100).optional(),
    sessionId: z.string().max(100).optional(),
  });
export type SpeechTtsRequest = z.infer<typeof SpeechTtsRequestSchema>;

/** POST /api/dev/sessions request body */
export const DevCreateSessionRequestSchema = z.object({
    userId: z.string().min(1),
  });
export type DevCreateSessionRequest = z.infer<typeof DevCreateSessionRequestSchema>;

/** POST /api/dev/roleplay/sessions request body. Creates a fresh roleplay_runner session for the given situation slug (resolves RolePlayTemplate by courseId + slug). Identify the driving user by `userId` or `email` (id wins when both are set) — the user must already exist. Dev/test only. */
export const DevRoleplayStartRequestSchema = z.object({
    userId: z.string().min(1).optional(),
    email: z.string().min(1).optional(),
    situationSlug: z.string().min(1),
    courseId: z.string().optional(),
  });
export type DevRoleplayStartRequest = z.infer<typeof DevRoleplayStartRequestSchema>;

/** POST /api/dev/roleplay/sessions/:sessionId/turn request body. Send the learner's message to drive one assistant turn synchronously. Omit `message` (or send empty) to drive the AI-initiated opening turn. */
export const DevRoleplayTurnRequestSchema = z.object({
    message: z.string().optional(),
  });
export type DevRoleplayTurnRequest = z.infer<typeof DevRoleplayTurnRequestSchema>;

/** POST /api/dev/test-users request body. Creates a disposable, pre-confirmed Supabase auth user for automated tests. The address is always generated by the server in the reserved test pattern — callers cannot supply one, which is what keeps the delete/cleanup guards meaningful. */
export const DevCreateTestUserRequestSchema = z.object({
    runId: z.string().max(64).optional(),
    ttlMinutes: z.number().int().min(1).max(1440).optional(),
    password: z.string().min(6).max(72).optional(),
    email: z.string().optional(),
    confirmed: z.boolean().optional(),
  });
export type DevCreateTestUserRequest = z.infer<typeof DevCreateTestUserRequestSchema>;

/** POST /api/dev/test-users/recovery-otp request body. Returns the 6-digit code Supabase would have emailed, WITHOUT sending mail — the email-free way to test the password-reset and sign-up-confirmation flows. */
export const DevTestUserOtpRequestSchema = z.object({
    email: z.string().min(1),
    type: z.enum(['recovery', 'signup']).optional(),
  });
export type DevTestUserOtpRequest = z.infer<typeof DevTestUserOtpRequestSchema>;

/** POST /api/dev/test-users/cleanup request body. Sweeps abandoned test users. With no fields, deletes every EXPIRED test user (the safe default). Only ever touches addresses matching the reserved test-user pattern. */
export const DevCleanupTestUsersRequestSchema = z.object({
    runId: z.string().max(64).optional(),
    all: z.boolean().optional(),
  });
export type DevCleanupTestUsersRequest = z.infer<typeof DevCleanupTestUsersRequestSchema>;

/** POST /api/conversation/sessions/:id/participants request body */
export const AddParticipantRequestSchema = z.object({
    userId: z.string(),
  });
export type AddParticipantRequest = z.infer<typeof AddParticipantRequestSchema>;

/** POST /api/lessons/check-updates request body */
export const CheckLessonUpdatesRequestSchema = z.object({
    courses: z.array(z.object({
      courseId: z.string(),
      lessonVersion: z.string(),
    })),
  });
export type CheckLessonUpdatesRequest = z.infer<typeof CheckLessonUpdatesRequestSchema>;

/** POST /api/admin/messages/force-update — blocking update prompt */
export const CreateForceUpdateMessageRequestSchema = z.object({
    maxAppVersion: z.string(),
    startsAt: z.string().optional(),
    expiresAt: z.string().optional(),
  });
export type CreateForceUpdateMessageRequest = z.infer<typeof CreateForceUpdateMessageRequestSchema>;

/** POST /api/admin/messages/soft-update — dismissable update suggestion */
export const CreateSoftUpdateMessageRequestSchema = z.object({
    maxAppVersion: z.string(),
    startsAt: z.string().optional(),
    expiresAt: z.string().optional(),
  });
export type CreateSoftUpdateMessageRequest = z.infer<typeof CreateSoftUpdateMessageRequestSchema>;

/** POST /api/admin/messages/announcement — general announcement modal */
export const CreateAnnouncementMessageRequestSchema = z.object({
    startsAt: z.string().optional(),
    expiresAt: z.string().optional(),
    locales: z.array(z.string()).optional(),
    subscriptionPlans: z.array(z.enum(['free', 'trial', 'pro'])).optional(),
  });
export type CreateAnnouncementMessageRequest = z.infer<typeof CreateAnnouncementMessageRequestSchema>;

/** POST /api/admin/messages/banner-notice — non-intrusive banner */
export const CreateBannerNoticeMessageRequestSchema = z.object({
    startsAt: z.string().optional(),
    expiresAt: z.string().optional(),
    locales: z.array(z.string()).optional(),
    subscriptionPlans: z.array(z.enum(['free', 'trial', 'pro'])).optional(),
  });
export type CreateBannerNoticeMessageRequest = z.infer<typeof CreateBannerNoticeMessageRequestSchema>;

/** POST /api/audio/episodes/:slug/progress request body */
export const SaveAudioProgressRequestSchema = z.object({
    positionMs: z.number().int().min(0),
    completed: z.boolean(),
  });
export type SaveAudioProgressRequest = z.infer<typeof SaveAudioProgressRequestSchema>;

/** HTTP request schemas keyed by name — for runtime validation */
export const HttpRequestSchemas = {
  SyncUserRequest: SyncUserRequestSchema,
  UpdatePreferencesRequest: UpdatePreferencesRequestSchema,
  UpdateCoursePreferenceRequest: UpdateCoursePreferenceRequestSchema,
  CreateSessionRequest: CreateSessionRequestSchema,
  LessonCompleteRequest: LessonCompleteRequestSchema,
  LessonSearchRequest: LessonSearchRequestSchema,
  AiSearchRequest: AiSearchRequestSchema,
  GenerateLessonRequest: GenerateLessonRequestSchema,
  ExerciseGenerationRequest: ExerciseGenerationRequestSchema,
  QuickPracticeRequest: QuickPracticeRequestSchema,
  SubmitFeedbackRequest: SubmitFeedbackRequestSchema,
  ReportAIContentRequest: ReportAIContentRequestSchema,
  RequestDeletionRequest: RequestDeletionRequestSchema,
  SpeechTtsRequest: SpeechTtsRequestSchema,
  DevCreateSessionRequest: DevCreateSessionRequestSchema,
  DevRoleplayStartRequest: DevRoleplayStartRequestSchema,
  DevRoleplayTurnRequest: DevRoleplayTurnRequestSchema,
  DevCreateTestUserRequest: DevCreateTestUserRequestSchema,
  DevTestUserOtpRequest: DevTestUserOtpRequestSchema,
  DevCleanupTestUsersRequest: DevCleanupTestUsersRequestSchema,
  AddParticipantRequest: AddParticipantRequestSchema,
  CheckLessonUpdatesRequest: CheckLessonUpdatesRequestSchema,
  CreateForceUpdateMessageRequest: CreateForceUpdateMessageRequestSchema,
  CreateSoftUpdateMessageRequest: CreateSoftUpdateMessageRequestSchema,
  CreateAnnouncementMessageRequest: CreateAnnouncementMessageRequestSchema,
  CreateBannerNoticeMessageRequest: CreateBannerNoticeMessageRequestSchema,
  SaveAudioProgressRequest: SaveAudioProgressRequestSchema,
} as const;

// ══════════════════════════════════════════════════════════════
// Query Schemas (z.coerce for number/integer — query params are strings)
// ══════════════════════════════════════════════════════════════

/** GET /api/lessons query params */
export const ListLessonsQuerySchema = z.object({
    level: z.string().optional(),
    category: z.string().optional(),
    limit: z.coerce.number().int().min(1).max(50).default(20),
    offset: z.coerce.number().int().min(0).default(0),
  });
export type ListLessonsQuery = z.infer<typeof ListLessonsQuerySchema>;

/** GET /api/lessons/path query params */
export const LessonPathQuerySchema = z.object({
    level: z.enum(['A1', 'A2', 'B1', 'B2', 'C1', 'C2']),
  });
export type LessonPathQuery = z.infer<typeof LessonPathQuerySchema>;

/** GET /api/lessons/recommended query params */
export const RecommendedLessonsQuerySchema = z.object({
    limit: z.coerce.number().int().min(1).max(10).default(5),
  });
export type RecommendedLessonsQuery = z.infer<typeof RecommendedLessonsQuerySchema>;

/** GET /api/lessons/scheduled query params */
export const ScheduledLessonsQuerySchema = z.object({
    limit: z.coerce.number().int().min(1).max(50).default(20),
  });
export type ScheduledLessonsQuery = z.infer<typeof ScheduledLessonsQuerySchema>;

/** GET /api/conversation/sessions query params */
export const ListSessionsQuerySchema = z.object({
    limit: z.coerce.number().int().min(1).max(50).default(20),
    offset: z.coerce.number().int().min(0).default(0),
  });
export type ListSessionsQuery = z.infer<typeof ListSessionsQuerySchema>;

/** GET /api/reports/ai-content/my-reports query params */
export const MyReportsQuerySchema = z.object({
    limit: z.coerce.number().int().min(1).max(50).default(10),
    offset: z.coerce.number().int().min(0).default(0),
  });
export type MyReportsQuery = z.infer<typeof MyReportsQuerySchema>;

/** POST /api/jobs/reconcile-subscriptions query params */
export const ReconcileSubscriptionsQuerySchema = z.object({
    full: z.enum(['true', 'false']).optional(),
    continuationToken: z.string().optional(),
  });
export type ReconcileSubscriptionsQuery = z.infer<typeof ReconcileSubscriptionsQuerySchema>;

/** GET /api/roleplay/templates query params */
export const RolePlayTemplateListQuerySchema = z.object({
    courseId: z.string(),
  });
export type RolePlayTemplateListQuery = z.infer<typeof RolePlayTemplateListQuerySchema>;

/** GET /api/roleplay/templates/:id query params */
export const RolePlayTemplateDetailQuerySchema = z.object({
    courseId: z.string(),
  });
export type RolePlayTemplateDetailQuery = z.infer<typeof RolePlayTemplateDetailQuerySchema>;

/** GET /api/roleplay/collections query params */
export const RolePlayCollectionListQuerySchema = z.object({
    courseId: z.string(),
    variant: z.string().optional(),
  });
export type RolePlayCollectionListQuery = z.infer<typeof RolePlayCollectionListQuerySchema>;

/** GET /api/roleplay/collections/:slug query params */
export const RolePlayCollectionDetailQuerySchema = z.object({
    courseId: z.string(),
    variant: z.string().optional(),
  });
export type RolePlayCollectionDetailQuery = z.infer<typeof RolePlayCollectionDetailQuerySchema>;

/** GET /api/roleplay/templates/search query params. `q` matches against title and scenario across all locales the row carries (the result set is course-wide; client filters further by collection if needed). */
export const RolePlayTemplateSearchQuerySchema = z.object({
    courseId: z.string(),
    q: z.string().optional(),
    difficulty: z.string().optional(),
    completed: z.enum(['true', 'false']).optional(),
    variant: z.string().optional(),
  });
export type RolePlayTemplateSearchQuery = z.infer<typeof RolePlayTemplateSearchQuerySchema>;

/** GET /api/vocab/items query params. Filters apply against the user UserVocabUsage row (joined server-side); items the user has never encountered are reported as status="new". */
export const VocabItemListQuerySchema = z.object({
    courseId: z.string(),
    status: z.string().optional(),
    dueForReview: z.enum(['true', 'false']).optional(),
    limit: z.string().optional(),
    offset: z.string().optional(),
  });
export type VocabItemListQuery = z.infer<typeof VocabItemListQuerySchema>;

/** GET /api/vocab/items/:id query params */
export const VocabItemDetailQuerySchema = z.object({
    courseId: z.string(),
  });
export type VocabItemDetailQuery = z.infer<typeof VocabItemDetailQuerySchema>;

/** GET /api/vocab/summary query params */
export const VocabSummaryQuerySchema = z.object({
    courseId: z.string(),
  });
export type VocabSummaryQuery = z.infer<typeof VocabSummaryQuerySchema>;

/** GET /api/courses/capabilities. `courseId` only — the source and target locales come from the learner's own preferences, so a client cannot ask "what would en-GB look like" and act on an answer that is not theirs. */
export const TargetCapabilitiesQuerySchema = z.object({
    courseId: z.string(),
  });
export type TargetCapabilitiesQuery = z.infer<typeof TargetCapabilitiesQuerySchema>;

/** GET /api/vocab/sets and /api/vocab/sets/:slug query params. Sets are course-scoped (VSET-007) — a member reaches a course only through its headword, so the course cannot be inferred from the slug. */
export const VocabSetsQuerySchema = z.object({
    courseId: z.string(),
  });
export type VocabSetsQuery = z.infer<typeof VocabSetsQuerySchema>;

/** GET /api/vocab/expressions query params. Same shape as VocabItemListQuery. */
export const ExpressionItemListQuerySchema = z.object({
    courseId: z.string(),
    status: z.string().optional(),
    dueForReview: z.enum(['true', 'false']).optional(),
    limit: z.string().optional(),
    offset: z.string().optional(),
  });
export type ExpressionItemListQuery = z.infer<typeof ExpressionItemListQuerySchema>;

/** GET /api/vocab/expressions/:id query params */
export const ExpressionItemDetailQuerySchema = z.object({
    courseId: z.string(),
  });
export type ExpressionItemDetailQuery = z.infer<typeof ExpressionItemDetailQuerySchema>;

/** POST /api/conversation/sessions/:id/messages/:messageId/analyze query params */
export const AnalyzeMessageQuerySchema = z.object({
    force: z.enum(['true', 'false']).optional(),
  });
export type AnalyzeMessageQuery = z.infer<typeof AnalyzeMessageQuerySchema>;

/** GET /api/audio/series query params */
export const AudioSeriesListQuerySchema = z.object({
    courseId: z.string(),
    level: z.enum(['A1', 'A2', 'B1', 'B2', 'C1', 'C2']).optional(),
  });
export type AudioSeriesListQuery = z.infer<typeof AudioSeriesListQuerySchema>;

/** GET /api/audio/episodes/:slug query params */
export const AudioEpisodeQuerySchema = z.object({
    teachingLanguage: z.enum(['source', 'target']).optional(),
  });
export type AudioEpisodeQuery = z.infer<typeof AudioEpisodeQuerySchema>;

/** GET /api/audio/progress query params */
export const AudioProgressListQuerySchema = z.object({
    courseId: z.string().optional(),
  });
export type AudioProgressListQuery = z.infer<typeof AudioProgressListQuerySchema>;

/** GET /api/admin/costs query params (ADR-026) */
export const AdminCostsQuerySchema = z.object({
    from: z.string().optional(),
    to: z.string().optional(),
    scope: z.enum(['global', 'user']).default('global'),
    environment: z.enum(['development', 'staging', 'production', 'test']).default('production'),
  });
export type AdminCostsQuery = z.infer<typeof AdminCostsQuerySchema>;

/** HTTP query schemas keyed by name — for runtime validation */
export const HttpQuerySchemas = {
  ListLessonsQuery: ListLessonsQuerySchema,
  LessonPathQuery: LessonPathQuerySchema,
  RecommendedLessonsQuery: RecommendedLessonsQuerySchema,
  ScheduledLessonsQuery: ScheduledLessonsQuerySchema,
  ListSessionsQuery: ListSessionsQuerySchema,
  MyReportsQuery: MyReportsQuerySchema,
  ReconcileSubscriptionsQuery: ReconcileSubscriptionsQuerySchema,
  RolePlayTemplateListQuery: RolePlayTemplateListQuerySchema,
  RolePlayTemplateDetailQuery: RolePlayTemplateDetailQuerySchema,
  RolePlayCollectionListQuery: RolePlayCollectionListQuerySchema,
  RolePlayCollectionDetailQuery: RolePlayCollectionDetailQuerySchema,
  RolePlayTemplateSearchQuery: RolePlayTemplateSearchQuerySchema,
  VocabItemListQuery: VocabItemListQuerySchema,
  VocabItemDetailQuery: VocabItemDetailQuerySchema,
  VocabSummaryQuery: VocabSummaryQuerySchema,
  TargetCapabilitiesQuery: TargetCapabilitiesQuerySchema,
  VocabSetsQuery: VocabSetsQuerySchema,
  ExpressionItemListQuery: ExpressionItemListQuerySchema,
  ExpressionItemDetailQuery: ExpressionItemDetailQuerySchema,
  AnalyzeMessageQuery: AnalyzeMessageQuerySchema,
  AudioSeriesListQuery: AudioSeriesListQuerySchema,
  AudioEpisodeQuery: AudioEpisodeQuerySchema,
  AudioProgressListQuery: AudioProgressListQuerySchema,
  AdminCostsQuery: AdminCostsQuerySchema,
} as const;

